//English
export const language = {
    //2020-10-26-ljm增加 弹窗提示以及翻译
    meassage:{
        leanMore:'Kom meer te weten',
        skip:'Overslaan',
        activate:'Activeren',
        emailSend: 'Email verzonden!',
        },
leftBanner: {
    liteWebsite: 'Websiteback-up',
    liteClone: 'Websitekloon',
    liteFile: 'Lite File',
    logoSlogan: 'The Go-To Choice for Cloud Transfer',
    cloudEscription: 'Focus op overdracht tussen clouds',
    commonTools: 'Gereedschappen',
    cloudDrives: 'Mijn clouddrives',
    onlineServices: 'Mijn onlinediensten',
    inviteFriends: 'Nodig vrienden uit',
    taskList: 'Takenlijst',
    cloudTransfer: 'Cloudoverdracht',
    cloudSync: 'Cloudsynchronisatie',
    cloudBackup:'Cloud Backup',
    btLink: 'Uploaden op afstand',
    teamTransfer:'Teamoverdracht',
    shares: 'Aandelen',
    emailTransfer: 'E-mailmigratie',
    instagramDownload: 'Instagram Downloader',
    videoDownload: 'Video Downloader',
    webDownload: 'Afbeeldingen Downloader',
    addCloud: 'Clouds toevoegen',
    addEmail: 'Clouds en e-mails toevoegen',
    manageClouds: 'Clouds en e-mails beheren',
    manageClouds2: 'Cloud-schijven beheren',
    encryption: 'encryptie',
    edit: 'Opnieuw toevoegen',
    remove: 'Verwijderen',
    createTask: 'Taak maken',
    createTaskText: 'De meest voorkomende taken kunt u hier aanmaken.',
    gotIt: 'Begrepen',
    bigWriteEncrypt: 'Encryptie',
    encryptionText: 'U kunt hier cloudbestandsversleuteling instellen.',
    addCloudText: 'Klik hier om je cloudopslag en e-mail te verbinden met MultCloud.',
    switchTxt: 'Schakel over naar de klassieke MultCloud',
    switchTip:'Schakel over naar klassieke MultCloud',
    switchTipDes:'U kunt hier overstappen naar de klassieke MultCloud.',
    new: 'Nieuw',
},
common: {
    addCloud: 'Wolk toevoegen',
    addEmail: 'E-mail toevoegen',
    options: 'Opties',
    schedule: 'Schema',
    ok: 'OK',
    save: 'Redden',
    add: 'Toevoegen',
    upgradeNow: 'Waardeer nu op',
    from: 'Van',
    to: 'Naar',
    result: 'Resultaat',
    fileProcess: 'Bestanden verwerkt',
    transferFiles:'Bestanden',
    dataProcess: 'Gegevens verwerkt',
    startTime: 'Starttijd',
    currentRate: 'Huidig tarief',
    endTime: 'Eindtijd',
    timeRemaining: 'Overgebleven tijd',
    averageRate: 'Gemiddelde score',
    averageRateSpecial: 'Gem. tarief',
    viewFailed: 'Bekijk mislukte bestanden',
    fileSuccess: 'Succes bij het overbrengen van alle bestanden',
    size: 'Maat',
    executedTimes: 'Uitgevoerde tijden',
    sourceDir: 'Bronmap',
    cause: 'Oorzaak',
    retry: 'Opnieuw proberen',
    retryMin: 'Opnieuw proberen',
    clean: 'Schoon',
    properties: 'Eigenschappen',
    copy: 'Kopiëren',
    move: 'Beweging',
    multiSelect: 'Meerkeuze selectie',
    close: 'dichtbij',
    copyTo: 'Kopiëren naar',
    tranTo: 'aaaa',
    syncWith: 'aaaa',
    backupTo: 'aaaa',
    download: 'Downloaden',
    delete: 'Verwijderen',
    more: 'Meer',
    preview: 'Voorbeeld',
    share: 'Deel',
    shareWith: 'Deel met MultCloud',
    shareTransfer: 'Maak een overdracht aan',
    encrypt: 'Versleutelen',
    encryptFile: 'Alleen bestand versleutelen',
    encryptFileName: 'Versleutel bestand en naam',
    decrypt: 'Ontsleutelen',
    decryptFile: 'Alleen bestand decoderen',
    decryptFileName: 'Decodeer bestand en naam',
    onedriveBusinessContentNote: 'Hint',
    oneDrive4BusinessContent: 'Als u een beheerder bent en een Microsoft 365-licentie aan een gebruiker hebt toegewezen maar een "Toegang geweigerd" foutmelding ontvangt wanneer u probeert de map van de gebruiker via MultCloud te openen, probeer dan de volgende stappen:',
    oneDrive4BusinessTips1: 'Ga naar "Beheer". Selecteer "Gebruikers" > tabblad "Actieve gebruikers" > Selecteer de optie "Productlicentie beheren".',
    oneDrive4BusinessTips2: 'Ga naar het tabblad "OneDrive" en klik op "Link naar bestand maken". Ga vervolgens terug naar MultCloud en probeer opnieuw toegang te krijgen tot het account.',
    oneDrive4BusinessStep1: 'Stap 1. ',
    oneDrive4BusinessStep2: 'Stap 2. ',
    upStep: 'Vorige',
    nextStep: 'Volgende',
    complete: 'Afronden',
    cut: 'Snee',
    viewDetails: 'Details bekijken',
    toOfficialSite: 'Officiële site',
    btLinkTask: 'Taak op afstand',
    fileName: 'Bestandsnaam',
    itemsSelected: 'geselecteerde artikelen',
    dateModified: 'Datum gewijzigd',
    rename: 'Hernoemen',
    paste: 'Plakken',
    btLink: 'Uploaden op afstand',
    load: 'Bezig met laden',
    status: 'Toestand',
    operate: 'Bedienen',
    failure: 'Mislukking',
    patial:'Gedeeltelijk succes',
    link: 'Koppeling',
    cleanList: 'Schone lijst',
    type: 'Type',
    account: 'Rekening',
    name: 'Naam',
    selectFailedFile: 'Selecteer alstublieft het mislukte bestand',
    transferring: 'Overdragen',
    newPassword: 'nieuw paswoord',
    confirmPassword: 'bevestig wachtwoord',
    done: 'Klaar',
    no: 'Nee',
    yes: 'Ja',
    attention: 'Aandacht',
    cancel: 'Annuleren',
    unsubscribe: 'Afmelden',
    reactivate: 'Heractiveer het',
    sureCleanAll: 'Weet u zeker dat u alle voltooide taken wilt wissen?',
    failedFiles: 'Mislukte bestanden',
    minTo: 'naar',
    retryAll: 'Probeer alles opnieuw',
    viewProgress: 'Bekijk de voortgang',
    taskNotRun: 'Deze taak wordt niet uitgevoerd.',
    success: 'Succes',
    canceled: 'Geannuleerd',
    patial: 'Gedeeltelijk succes',
    syncDetails: 'Synchronisatiedetails',
    width: 'Breedte',
    sync: 'Synchroniseren',
    targetCloud: 'Doel-clouddrives',
    running: 'Rennen',
    preparing: 'voorbereidingen treffen',
    waiting: 'Aan het wachten',
    target: 'Doel',
    noVip: 'U kunt nu maximaal 2 bestanden tegelijk overbrengen. Upgrade naar een premium service om er maximaal 10 te hebben!',
    vipThanks: 'Bedankt voor het abonneren op onze service. U kunt nu maximaal 10 bestanden tegelijk overbrengen.',
    emailAccount: 'Email account',
    with: 'Met',
    syncing: 'Synchroniseren',
    selectAll: 'Selecteer alles',
    date: 'Datum',
    failed: 'Mislukt',
    skip: 'Overslaan',
    replace: 'Vervangen',
    ready: 'Klaar',
    connecting: 'Verbinden',
    account: 'Rekening',
    selectNull: 'Selecteer alstublieft een doelmap.',
    selectOther: 'Deze map kan niet worden geselecteerd voor het plakken van bestanden. U kunt de submappen of andere mappen ervan selecteren.',
    editShare: 'Deel bewerken',
    toSource: 'Naar Bron',
    copyLink: 'Kopieer link',
    toShare: 'Te delen',
    report: 'Rapport',
    expand: 'Uitbreiden',
    shrink: 'Krimpen',
    filterHolder:'Voer hier een bestandsextensie in. Bijvoorbeeld mp4',
    countFiles:'Bestanden tellen',
    upgradeMulti:'Upgrade naar Multithread',
     team: 'Teambestanden',
     loadData:'Gegevens laden, even geduld alstublieft.',
     getAccountInfo:'Kan de accountinformatie niet ophalen, log alstublieft opnieuw in en probeer het opnieuw.',
    loadingData:'Data laden ...',
    failedEmptyTip: 'Kan mislukte bestanden niet laden. Neem alstublieft contact op met <a href="mailto:support@multcloud.com">support@multcloud.com</a> voor verdere hulp.',
    runNow:'Ren nu',
    emailFilter: 'E-mailfilter',
    me: "Mij",
    reset: "Opnieuw instellen",
    apply: "Toepassen",
    failureReason: 'Reden van mislukking',
    countingFilesTip: 'Aan het tellen ({num} bestanden)',
    taskName: 'Taaknaam',
    frequency: 'frequentie:',
    canceling: 'Annuleren...',
},
rightTopBanner: {
    navTransfer: 'Cloud-overdracht',
    navInstagram: 'Instagram Downloader',
    navVideo: 'Video Downloader',
    navWeb: 'Afbeeldingen Downloader',
    traffic: 'Verkeer',
    upgrade: 'Upgrade',
    settings: 'Instellingen',
    changePassword: 'Verander wachtwoord',
    changeName: 'Naam veranderen',
    bindEmail: 'E-mail binden',
    deleteAccount: 'Account verwijderen',
    language: 'Taal',
    help: 'Hulp',
    notifications: 'Meldingen',
    notification: 'Kennisgeving',
    subAccounts: 'Sub-accounts',
    logout: 'Uitloggen',
    tutorials: 'Handleidingen',
    contact: 'Contact',
    limitsClouds: 'Grenzen van wolken',
    faq: 'FAQ',
    unlimited:'Onbeperkt',
    purTraffic: 'Koopverkeer',
    unlimitedPlan: 'Onbeperkt abonnement',
    monthlyUnlimitedPlan: 'Maandelijks onbeperkt abonnement',
    rememberOriginal: 'Onthoud alsjeblieft je originele gebruikersnaam:',
    andPassword: 'en wachtwoord',
    bindEmailOpen: 'Het beste is <span style="color:#8a96e3;cursor:pointer;" id="bindEmailOpen">bind uw e-mailadres en wijzig het standaardwachtwoord </span> voor veiligheid en gemak.',
    lifeSwitchTip: 'Met de LIFETIME UNLIMITED-service kunt u bestanden zonder verkeerslimieten tussen clouds overbrengen.',
    lifeTimePlan: 'Levenslang onbeperkt',
    browserPrompt:'Voor een betere gebruikerservaring raden we aan Google Chrome te gebruiken.',
    lifeTimeNotice:'U bent een MultCloud Lifetime Unlimited-gebruiker.',
    subAccount:"Sub-account",
    bindMailTips:"Bind alstublieft uw e-mail om cloud-bestandsoverdracht te ontgrendelen en het meeste uit MultCloud te halen.",
    bind:"Binden",
},
popup: {
    userStarPopup: {
        starDesc: "Hoe is je ervaring tot nu toe?",
        ok: "OK",
        thankYou: "Bedankt!",
        thankYouDesc: "Als u even de tijd zou kunnen nemen om uw echte en eerlijke ervaring met het gebruik van ons product te delen, zou het ons kleine team gemotiveerd houden om MultCloud nog beter te maken.",
        reviewStart: "Beoordeel ons op",
        reviewEnd: "",
        feedbackTitle: "Hoe kunnen we verbeteren?",
        feedbackDesc: "Voeg uw feedback toe",
        feedbackBtn: "Indienen",
        feedbackYes: "Bedankt voor de feedback.",
        feedbackNo: "Voer uw feedback in.",
    },
    addCloudPopup: {
        endpointOptional:'Eindpunt (optioneel)',
        //2020.09.23 添加NAS云盘
        addNas: 'VOEG NAS toe',
        addNasFtpDes: `Verbinden met NAS via FTP. Weet je niet hoe je FTP voor NAS moet instellen? <a href="https://www.multcloud.com/help/enable-ftp-service-on-synology-nas.html" target="_blank" class='add-cloud-link'>Klik dan hier</a>`,
        addNasWebDes: `Verbinden met NAS via WebDAV. Weet je niet hoe je WebDAV voor NAS moet instellen? <a href="https://www.multcloud.com/help/enable-webdav-service-on-synology-nas.html" target="_blank" class='add-cloud-link'>Klik dan hier</a>`,
        bucketName: 'Naam van emmer',
        endpoint: 'Eindpunt',
        accessKeyId: 'Toegangssleutel-ID',
        idriveKeyId: 'Toegangssleutel-ID',
        secretAccessKey: 'Geheime toegangssleutel',
        idriveSecretAccessKey: 'Geheime toegangssleutel',
        displayName: 'Weergavenaam',
        addFtp: 'FTP toevoegen',
        addFtpDes: 'Om uw FTP te verbinden heeft MultCloud uw authenticatiegegevens nodig.',
        egnyteTip: `Tips: Om uw sleutel en geheim te verkrijgen, heeft u de Egnyte API-beheer-ID nodig. Als u er geen heeft, kunt u zich <a href="https://developers.egnyte.com/member/register" target="_blank" class='add-cloud-link'>hier registreren</a>.`,
        icedriveTip: 'Notitie:',
        icedriveTip1: '1. Ondersteuning alleen voor Icedrive Premium-accounts.',
        icedriveTip2: '2. Klik op je Icedrive-gebruikersnaam -> 2FA & Toegang -> WebDAV -> Inschakelen -> Sleutel weergeven. De toegangssleutel is het wachtwoord.',
        iCloudPhotosTip: 'Tips:',
        iCloudPhotosTip1: '1. Voordat u uw iCloud-foto\'s met MultCloud verbindt, zorg ervoor dat \"Toegang tot iCloud-gegevens op het web\" is ingeschakeld.',
        iCloudPhotosTip1Q: `Webtoegang tot uw iCloud-gegevens beheren:<br><br>Op iPhone of iPad<br>1. Open de app Instellingen.<br>2. Tik op je naam en vervolgens op iCloud.<br><br>3. Tik om Toegang tot iCloud-gegevens op internet in of uit te schakelen.<br>
        <br>On Mac<br>1. Choose Apple menu > System Settings.<br>2. Click your name, then click iCloud.<br>3. Click to turn off or turn on Access iCloud Data on the Web.`,
        iCloudPhotosTip2: '2. iCloud Foto\'s ondersteunt alleen de volgende afbeeldingsformaten: jfif, pjpeg, jpeg, pjp, jpg, HEIC.',
        server: 'server',
        protocol: 'Protocol',
        port: 'Poort',
        passive: 'Passieve modus',
        passphrase: 'Wachtwoordzin',
        explanation: 'Om verbinding te maken met FTP, moet het voorvoegsel \"ftp://\" zijn, anders wordt het voorvoegsel gemist. Als uw FTP-poort niet de standaard is, maar een speciaal poortnummer is, zoals 21, gebruik dan het onderstaande formaat om de poort op te geven: ftp: //ftp.myhost.com:21',
        userName: 'Gebruikersnaam',
        passWord: 'Wachtwoord',
        advanced: 'Geavanceerd',
        commFTP: 'Gewone FTP',
        transMode: 'Overdrachtsmodus',
        encoding: 'Codering',
        path: 'Pad (optioneel)',
        cloudName: 'Cloudnaam',
        cloudService: 'Cloud dienstverlening',
        addedTime: 'Toegevoegde tijd',
        usedSpace: 'Gebruikte ruimte',
        totalSpace: 'Totale ruimte',
        iCloudUsedSpace: 'iCloud Foto\'s-opslag',
        iCloudDriveUsedSpace: 'iCloud Drive-opslag',
        iCloudTotalSpace: 'Totale iCloud-opslag',
        iCloudDriveTotalSpace: 'Totale iCloud-opslag',
        removeContent: 'Sommige cloudoverdrachtstaken zijn gebaseerd op deze cloud. Wil je het toch verwijderen?',
        baiDuTips: 'Vanwege de beperkingen van Baidu Yunpan kunnen bestanden/mappen alleen worden overgebracht naar "全部文件/我的应用数据/Multcloud".',
        google_driveTips: 'Wanneer u bestanden of mappen van Google Drive naar andere overzet, zorg er dan voor dat er niet dezelfde bestandsnamen in dezelfde map staan.',
        mySQLQuestion: 'U moet uw IP-adres van de MySQL-server invoeren in het serverveld en de standaardpoort is 3306, of u moet uw aangepaste poort invoeren.',
        webDavQuestion: `Als u een beveiligde SSL-verbinding gebruikt, voeg dan het voorvoegsel \"https://\" toe aan uw host of doe niets en de standaardpoort is 443. Anders moet het voorvoegsel \"http://\" zijn en de standaardpoort 80.
        bijv. https://dav.box.com/dav`,
        egnyteQuestion: 'Log in op Engnyte en vind uw domein in de adresbalk. Voer het domein in dit formaat in: b.v. https://aomeitech.egnyte.com/',
        ownCloudQuestion: 'Als u een beveiligde SSL-verbinding gebruikt, voeg dan het voorvoegsel \"https://\" toe aan uw host of doe niets en de standaardpoort is 443. Anders moet het voorvoegsel \"http://\" zijn en de standaardpoort 80',
        amazonQuestion: `Bezoek de pagina voor <a href="https://www.multcloud.com/tutorials/s3-key.html" target="_blank" class='add-cloud-link'>hoe u de Amazon S3-toegangssleutel kunt verkrijgen identiteitskaart.</a>`,
        boxTips: `Box ondersteunt de overdracht van een enkel bestand groter dan 2GB niet.`,
        google_drive_sharedWithMeTips:'Wanneer u bestanden overbrengt naar mappen op de Shared With Me-schijf, zorg er dan voor dat u geautoriseerd bent met \"Uploadtoestemming\".',
        gSuiteSharedDriveTips:'Wanneer u bestanden overzet naar mappen van de gedeelde Drive, zorg er dan voor dat u geautoriseerd bent met \'Uploadtoestemming\'.',
        webDavTips: `1. Zorg ervoor dat je lees- en schrijfrechten hebt voordat je bestandshandelingen uitvoert, anders kan MultCloud mogelijk geen bestanden naar je WebDav overzetten.
        2. Zorg er alsjeblieft voor dat er voldoende ruimte is voor je handelingen. We kunnen de grootte tijdelijk niet identificeren.`,
        aDriveTips: 'We ondersteunen momenteel Personal Premium- en Business-accounts, maar geen Personal Basic-account.',
        yandexTips:  `1. Zorg er alsjeblieft voor dat er voldoende ruimte is voor je handelingen. We kunnen de grootte tijdelijk niet identificeren.
                      2.Als u het app-wachtwoord hebt ingeschakeld, voert u het app-wachtwoord in de wachtwoordbalk hierboven in. `,
        googlePhotosTips: `1.In de map \"Foto\'s\" kunnen alleen afbeeldingen, video\'s en andere mediabestanden worden opgeslagen, maar geen mappen.
        2.In de map \"Albums\" kunnen alleen albummappen worden opgeslagen, maar geen mediabestanden.
        3.De map \"Delen\" bevat alle albums die door u zijn gedeeld of de gedeelde albums waarvan u lid bent.
        4.Google Foto\'s ondersteunt alleen het uploaden van afbeeldingen, video\'s en andere mediabestanden. En als u de MultCloud-uploadfunctie gebruikt, kunt u alleen bestanden uploaden naar de albummappen die zijn gemaakt of gedeeld door MultCloud.
        5.Wanneer u de MultCloud-brondeelfunctie gebruikt, kunt u alleen de albums delen die door MultCloud zijn gemaakt.
        6.Alle titelloze albums worden weergegeven als \"Zonder titel\".
        7.Momenteel is de downloadfunctie beschikbaar, maar het downloaden van originele bestanden wordt niet ondersteund.
        8.Momenteel is er geen ondersteuning voor functies voor knippen, verwijderen en hernoemen. En u kunt de functies die afhankelijk zijn van deze bewerkingen niet gebruiken.`,
        googlePhotosV2Tips: `1.In de map \"Foto\'s\" kunnen alleen afbeeldingen, video\'s en andere mediabestanden worden opgeslagen, maar geen mappen.
        2.In de map \"Albums\" kunnen alleen albummappen worden opgeslagen, maar geen mediabestanden.`,
        evernoteTips: `1. API-snelheidslimieten. <a href='https://dev.evernote.com/doc/articles/rate_limits.php' target="_blank" class='add-cloud-link'> Details bekijken>> </a>
          2. Wat zijn de systeemlimieten van Evernote? <a href='https://help.evernote.com/hc/en-us/articles/209005247-What-are-the-system-limits-of-Evernote-' target="_blank" class='add-cloud-link'>Details bekijken>></a>
          3. U kunt alleen een bestand van minder dan 50 MB uploaden naar de notitie.
          4. Kan de notitie-inhoudsbestanden (. ENML) niet hernoemen of verwijderen.
          5. Kan de notities alleen naar het notitieblok kopiëren.`,
        flickrTips: `1. U kunt alleen foto\'s of video\'s overbrengen naar Flickr.
        2. Mappen kunnen alleen worden overgebracht naar de map \"Albums\" en er kunnen geen submappen zijn onder de map \"Albums\".
        3. Bestanden kunnen alleen worden overgebracht naar de map \"Mijn Fotostream\" of \"Albums\" die u aanmaakt.
        4. Al uw bestanden zijn te vinden in de map \"Mijn Photostream\".
        5. Alle bestanden in de map \"Albums\" verwijzen naar de map \"Mijn Photostream\".`,
        mediafireTips: 'Het uploaden en downloaden van een leeg bestand wordt niet ondersteund. Het kan lang duren om een map te openen die veel bestanden bevat.',
        mySQLTips: `1. Uw database moet toegankelijk zijn vanaf onze IP-adressen, die 209.126.% zijn. U kunt een nieuwe gebruiker aanmaken via uw database of hostinterface. De MySQL-opdracht is als volgt:
       <span class='add-mysql-link'>VERLEEN DATABASES TONEN, SELECTEER, VERGRENDELD TAFELS, HERLADEN OP *.* NAAR gebruikersnaam@\'209.126.%\' GEIDENTIFICEERD DOOR \'wachtwoord\'</span>;
        2. Uw server moet mogelijk een firewallregel toevoegen met onze IP-adressen en de gebruikte poort (de standaardpoort is 3306) om normaal toegang te krijgen tot uw databases.`,
        hubiCTips: `1. Een hubiC-account kan slechts één keer worden toegevoegd.
        2. U kunt geen bestanden of mappen hernoemen of knippen.
        3. Het kan wat traag zijn om mappen met veel bestanden te verwijderen.
        4. hubiC ondersteunt niet de overdracht van een enkel bestand groter dan 5GB.
        5. Bestandsnamen mogen niet langer zijn dan 248 tekens en mapnamen zijn beperkt tot 256 tekens.`,
        gSuiteUpTips: `De verbinding tussen G Suite en MultCloud is alleen beschikbaar voor G Suite-beheerders. Om G Suite met MultCloud te verbinden, moet u onze G Suite Marketplace-app \"DOMEIN INSTALLEREN\" --- <a href='https://gsuite.google.com/marketplace/search/Cloud%20Transfer%20-%20MultCloud? hl=nl' target="_blank" class='add-cloud-link'>\"Cloudoverdracht - MultCloud\"</a> eerst.`,
        gSuiteTips: `1.U moet een <a href="https://support.google.com/a/answer/2405986?hl=en" target="_blank" class='add-cloud-link'> G Suite-beheerder</a zijn >.
                    2.Hoe controleer ik of het een beheerdersaccount is? Raadpleeg eerst deze link <a href='https://support.google.com/a/answer/2406043' target="_blank" class='add-cloud-link'> https://support.google. com/a/antwoord/2406043</a>. Ten tweede logt u in op uw Gsuite-account via de link. Ten derde kunt u de resultaten vinden onder de regel \'Een aangepaste rol maken\'.
                    3.De <a href='https://support.google.com/a/answer/60757?hl=en' target="_blank" class='add-cloud-link'>API-toegang</a> is ingeschakeld.
                    4.Voordat u deze clouddrive toevoegt, moet u onze <a href='https://gsuite.google.com/marketplace?hl=en' target="_blank" class='add-cloud-link'> G Suite Marketplace-app installeren </a> Eerst \'MultCloud voor G Suite\' en zorg ervoor dat de <a href='https://admin.google.com/' target="_blank" class='add-cloud-link'> configuratie is </a > klopt: de status is ingeschakeld en de gegevenstoegang is verleend.`,
        hiDriveTips: `1.Zorg ervoor dat u een account hebt waarop het WebDAV-protocol is ingeschakeld en lees-/schrijfrechten heeft voordat u met bestanden gaat werken, anders kan MultCloud mogelijk geen bestanden naar uw HiDrive overbrengen.
        2. Zorg ervoor dat er voldoende ruimte is voor uw activiteiten. We kunnen de omvang ervan tijdelijk niet identificeren.`,
        backblazeTips: `1.Elke bucketnaam moet minimaal 6 tekens lang zijn.
        2.Wanneer u een nieuwe applicatiesleutel maakt, werkt de oude niet meer.
        3.Bestandsnamen mogen niet beginnen met \"/\", eindigen op \"/\", of \"//\" bevatten.`,
        WEBDETips: `1.Zorg ervoor dat u lees-/schrijfrechten heeft voordat u bestanden uitvoert, anders kan MultCloud mogelijk geen bestanden naar uw Web.De overbrengen.
        2. Zorg ervoor dat er voldoende ruimte is voor uw activiteiten. We kunnen de omvang ervan tijdelijk niet identificeren.`,
        alfrescoTips: `Als gratis Alfresco-account bedraagt uw netwerkopslagruimte 10GB en de limiet voor de individuele bestandsgrootte 50 MB.`,
        cloudMeTips: `1.Zorg ervoor dat u lees-/schrijfrechten heeft voordat u bestanden gaat bewerken, anders kan MultCloud mogelijk geen bestanden naar uw CloudMe overbrengen.
        2. Zorg ervoor dat er voldoende ruimte is voor uw activiteiten. We kunnen de omvang ervan tijdelijk niet identificeren.`,
        myDriveTips: `Zorg ervoor dat er voldoende ruimte is voor uw activiteiten. We kunnen de omvang ervan tijdelijk niet identificeren.`,
        cubbyTips: `1.Zorg ervoor dat u lees-/schrijfrechten heeft voordat u bestanden gaat bewerken, anders kan MultCloud mogelijk geen bestanden naar uw Cubby overbrengen.
        2. Zorg ervoor dat er voldoende ruimte is voor uw activiteiten. We kunnen de omvang ervan tijdelijk niet identificeren.`,
        cloudType: 'Wolktype',
        notificationTip: `Bedankt voor het gebruik van de nieuwste MultCloud. Als u een probleem ondervindt, kunt u feedback sturen naar:<a href="mailto:support@multcloud.com">support@multcloud.com</a>, bedankt.`,
        notAbleAccess: 'Geen toegang tot Google Foto\'s Probleem opgelost',
        problemNotAccess: 'Het probleem dat u geen toegang heeft tot Google Foto\'s, is opgelost. Als u nog steeds geen toegang heeft tot Google Foto\'s, voeg deze dan opnieuw toe aan MultCloud.',
        noPrompt: 'Volgende keer niet meer vragen',
        addFeatures: 'Hieronder enkele nieuwe toegevoegde functies:',
        version: 'Versie:',
        applicationKey: 'applicatiesleutel',
        keyID: 'sleutelID',
        privateKey: 'Privésleutelbestand voor authenticatie (optioneel)',
        FTPTips:`1.Zorg ervoor dat u lees-/schrijfrechten heeft voordat u bestanden gaat bewerken, anders kan MultCloud mogelijk geen bestanden naar uw FTP overbrengen.
        2. Zorg ervoor dat er voldoende ruimte is voor uw activiteiten. We kunnen de omvang ervan tijdelijk niet identificeren.
        3. Als u geen toegang heeft tot uw FTP, voeg dan 209.126.103.1/19 en 207.38.89.1/24 toe aan de witte lijst van de firewall.`,
        //2021-10-14
        specialDropBoxBottom:`Als u toegang wilt tot uw persoonlijke cloud, klikt u op \"Toegang tot persoonlijke cloud\".`,
        specialDropBox:`Als je een Dropbox Business-beheerder bent en toegang wilt tot alle accounts van je organisatie, klik dan op \'Toegang tot organisatie\'.`,
        accessOrganization:'Toegang tot organisatie',
        accessPersonalCloud:'Toegang tot persoonlijke cloud',
        specialBoxBusiness:`Bent u een Business admin en wilt u toegang krijgen tot alle accounts van uw organisatie, klik dan op \"Toegang tot organisatie\".`,
        specialgSuite:`Als u een <a href='https://support.google.com/a/answer/2405986?hl=en' target="_blank" class='add-cloud-link'> Google Workspace-beheerder </a> en u wilt toegang tot alle accounts van uw organisatie, \"Admin Install\" onze Google Workspace Marketplace-app --- "<a href="https://gsuite.google.com/marketplace/app/cloud_transfer_multcloud/72136911391? hl=en" target="_blank" class='add-cloud-link'>Cloudoverdracht – MultCloud</a>" eerst. En klik vervolgens op \"Toegang tot organisatie\".`,
        specialOnedrive:`Als u een OneDrive voor Bedrijven-beheerder bent en toegang wilt tot alle accounts van uw organisatie, klik dan op \"Toegang tot organisatie\".`,
        iCloudPhotosTips:'MultCloud ondersteunt momenteel geen Apple ID zonder e-mail.',
        appleId: 'Apple-ID',
        addICloudPhotos: 'Voeg iCloud-foto\'s toe',
        addICloudDrive: 'Voeg iCloud Drive toe',
        fourShared: `Let op: de 4shared-autorisatie is <span style="color: red"> 2 uur geldig.</span> Voeg 4shared opnieuw toe en voer uw taken handmatig uit nadat deze is verlopen.`,
        fourSharedTips: `Let op: 4shared autorisatie is 2 uur geldig. Voeg 4shared opnieuw toe en voer uw taken handmatig uit nadat deze is verlopen.`,
    },
    cloudExploerPopup: {
        googlePhotosV2Tips: 'Tips voor Google Foto\'s',
        googlePhotosV2TipsDesc: 'Google heeft de Google Foto\'s API bijgewerkt per 7 mei 2025. Om deze wijzigingen te accommoderen, moeten we de volgende updates implementeren:',
        googlePhotosV2Tips1: 'De map "Albums" laat nu alleen albums zien die door MultCloud zijn gemaakt.',
        googlePhotosV2Tips2: 'De map "Foto\'s" laat nu alleen afbeeldingen zien die via MultCloud zijn geüpload.',
        googlePhotosV2Tips3: 'Om afbeeldingen van Google Foto\'s naar andere clouddiensten over te zetten, klik op de knop "Meer foto\'s toevoegen" en verleen MultCloud toegang tot de afbeeldingen die je wilt overzetten.',
        googlePhotosV2Tips4: 'Om afbeeldingen van andere clouddiensten naar Google Foto\'s over te zetten, let op: alleen mappen kunnen naar de map "Albums" worden overgezet, en alleen individuele afbeeldingen kunnen naar de map "Foto\'s" worden overgezet.',
        googlePhotosV2TipsShow: 'Dit niet meer tonen',
        googlePhotosV2AddMore: 'Meer foto\'s toevoegen',
        googlePhotosV2AddMoreTips: 'Klik hier om afbeeldingen toe te voegen die je aan MultCloud wilt toevoegen.',
        googlePhotosV2FolderName: 'Mapnaam',
        googlePhotosV2FolderNameInput: 'Voer een naam in voor de map waarin de afbeeldingen worden opgeslagen',
        googlePhotosV2NotSelect: 'Je hebt nog geen foto\'s toegevoegd. Klik op "Meer foto\'s toevoegen" om afbeeldingen aan MultCloud toe te voegen.',
        googlePhotosV2SelectAlbums: 'Je kunt alleen mappen opslaan in "Albums"',
        googlePhotosV2SelectAlbum: 'Je kunt alleen afbeeldingen en video\'s in deze map opslaan',
        googlePhotosV2SelectPhotos: 'Je kunt alleen afbeeldingen en video\'s opslaan in "Foto\'s"',
        googlePhotosV2SelectSession: 'Deze map kan niet als doel worden geselecteerd. Selecteer in plaats daarvan de map \'Albums\' of \'Foto\'s\'.',
        deleteContentEver: 'Weet u zeker dat u de geselecteerde items definitief wilt verwijderen?<br>Eenmaal verwijderd, kan het niet meer vanuit de prullenbak worden hersteld.',
        deleteContent: 'Weet u zeker dat u de geselecteerde items wilt verwijderen?',
        deleteConfirm: 'Bestandsverwijdering bevestigen?',
        deleteAction: 'Deze actie kan niet ongedaan worden gemaakt. Het bestand wordt permanent verwijderd.',
        deleteDeletion: 'Voer de bestandsnaam in om de verwijdering te bevestigen:',
        deleteDeletionOK: 'Voer de juiste bestandsnaam in om de verwijdering te bevestigen',
        detailedProgress: 'Gedetailleerde voortgang',
        highSpeed: 'Zoeken op hoge snelheid ondersteunt de volgende clouddrives',
        takeMoreTime: 'Bij de volgende clouddrives kan het langer duren',
        enterKeyWord: 'Voer het sleutelwoord in',
        highSpeedSearch: 'Zoeken op hoge snelheid',
        normalSearch: 'Normaal zoeken',
        shareWithOthers: 'Deel met anderen',
        inviteByEmail: 'Nodig mensen uit via e-mail',
        pleaseEnterEmail: 'Voer e-mailadressen in en scheid ze met een komma',
        addMessage: 'Voeg een bericht toe(Optioneel)',
        shareTo: 'Delen naar',
        noLink: 'Er is nog geen link gemaakt',
        createShare: 'Deel maken',
        cancelAllTask: 'Weet u zeker dat u alle taken wilt annuleren?',
        //2020/8/7-xth
        shareEmailTitle: 'Link via e-mail verzenden',
        // shareCommunityTitleLong: 'Title should be less than 128 characters',
        // shareCommunityDesLong: 'Description should be less than 256 characters',
        shareNotSupportSource: 'Deze cloudservice ondersteunt deze functie niet. Probeer een andere deeloptie',
        shareSendEmail: 'E-mail verzenden',
        generateLinkSuccess: 'Delen Link gemaakt',
        generateLinkFail: 'Kan de deellink niet maken',
        emailSentSuccessful: 'E-mails verzonden',
        emailSentNull: 'U heeft nog geen e-mailadres ingevoerd',
        emailSentNotice: 'Voer een correct e-mailadres in',
        linkCopySuccessful: 'Link gekopieerd!',
        sharePrivateLink: 'Link voor privé delen: ',
        sharePrivatePassword: ' Wachtwoord bekijken: ',
        cancelMyShareTask: 'Weet u zeker dat u het aandeel wilt annuleren? Deze link werkt niet meer voor iedereen die deze link heeft.',
        cancelMyShareOk: 'Ja, annuleer het',
        cancelMyShareNot: 'Nee, ik bewaar het',
        emailArrayToLong50: 'U kunt 50 e-mails tegelijk verzenden.',
        shareOnEmail: 'Link via e-mail verzenden',
        shareOnFacebook: 'Delen op Facebook',
        shareOnTwitter: 'Delen op Twitter',
        shareOnTumblr: 'Deel op Tumblr',
        shareOnPinterest: 'Deel op Pinterest',
        shareOnLinkedIn: 'Deel op LinkedIn',
        ceateShareError: 'Kan de share niet maken. Controleer uw netwerk.'
    },
    cloudTransferPopup: {
        pleaSelect: 'Selecteer alstublieft',
        schedule: 'Schema',
        //后又新增的
        checkScheduled: 'Vink het vakje \'Gepland\' van deze taak aan om de planningseditor te activeren.',
        addValidCloud: 'U moet een geldige clouddrive toevoegen',
         //2020-10-26-ljm增加
         cleanList:'Schone lijst'
    },
    personalCenter: {
        changePassword: ' Verander wachtwoord',
        changeName: 'Naam veranderen',
        deleteAccount: ' Account verwijderen',
        enterPassWord: 'Voer alsjeblieft je wachtwoord in.',
        note: 'Opmerking: laat ons alstublieft de reden weten waarom u weggaat. We zullen ons best doen om dit te corrigeren.',
        sureDeleteAccount: 'Weet je zeker dat je dit account wilt verwijderen?',
        unsubscribe: 'Voordat u dit account verwijdert, dient u zich eerst af te melden bij MultCloud.',
        bindEmail: 'E-mail binden',
        pleaseSwitch: 'Schakel over naar de klassieke MultCloud om de bestanden te decoderen.',
        switchOld: 'Schakel over naar klassiek',
        pleaseUnsubscribe: 'Schakel over naar de klassieke MultCloud om eerst uw premiumservice af te melden.',
        deletePremium: 'U staat op het punt een premium-account te verwijderen. Als je het eenmaal hebt verwijderd, kun je het nooit meer terugkrijgen. Weet je zeker dat je dit nog steeds wilt doen?'
    },
    remoteTaskPopup: {
        addLinkTask: ' Koppelingstaak toevoegen',
        validLink: 'Voer een geldige link in',
        saveCloud: 'Opslaan in de cloud',
        parseFail:'Mislukt om te parseren',
        inadmissibleRequest:'Een niet-ontvankelijk verzoek',
        createBtTask: 'BT-taak maken',
        savingPrivateRyun: 'Het redden van soldaat Ryun',
        emptySource: 'Voer een link in of upload een torrent-bestand',
        validTorrent: 'Het geselecteerde torrent-bestand is ongeldig',
        addTorrent: 'Torrent toevoegen',
        tip: ' Je hebt geen cloud geselecteerd om dit bestand op te slaan',
        torrentSelected:'Naam({num}/{all})',
        urlLinkSupported:"Kopieer en plak de link hier, http/https/magnet-links worden ondersteund.\nOpmerking: gebruik MultCloud niet om ongeautoriseerd, inbreukmakend gekopieerd materiaal te downloaden of te uploaden",
        torrentStore:'Selecteer een cloud om het torrent-bestand op te slaan',
        downloadLink:'Voer een downloadlink in',
        cancelTask:'Taak annuleren',
        cancelTaskContent:'Weet u zeker dat u de taak wilt annuleren?',
        parseTaskRunning:'MultCloud voert al een parseerproces uit. Ga naar \"Upload op afstand\" om dit te controleren.'
    },
    taskListPopup: {
        deleteTask: 'Taak verwijderen',
        pleaseSelect: 'Selecteer gegevens voordat u deze verwijdert.',
        sureDeleteTask: 'Weet u zeker dat u de taak(en) wilt verwijderen?',
        deleteSingleTask: 'Weet u zeker dat u de taak wilt verwijderen?',
        viewLogs: 'Bekijk logboeken',
        selectCloud: 'Selecteer de cloud om de bestanden op te slaan'
    },
    upgradeAccountPopup: {
        commonTitle: '5 cloud-naar-cloud-taken parallel',
        commonDes: 'Alsjeblieft, upgrade naar een abonnee en je kunt 5 cloud-naar-cloudtaken tegelijk uitvoeren.',
        upgradeAccount: 'Upgrade account',
        upgradeHeadTitle:'5 parallelle URL\'s of torrents',
        upgradeHeadContent:"Gratis gebruikers kunnen één overdrachts-URL of torrent-taak tegelijk hebben. Upgrade naar een abonnee en u kunt 5 overdrachts-URL- of torrent-taken tegelijk overbrengen.",
        currentPlan: 'Huidige plan',
        insufficientTraffic: 'Onvoldoende cloud-naar-cloud-verkeer',
        insufficientTrafficDes: 'Je hebt al het gratis dataverkeer van deze maand verbruikt. Om meer verkeer te krijgen, kunt u upgraden naar de premiumversie.',
        filter: 'Bestandsoverdracht/synchronisatiefilter',
        filterDes: 'Om het bestandsoverdracht-/synchronisatiefilter te activeren, moet u upgraden naar de premiumversie.',
        modes: 'Geavanceerde synchronisatiemodi',
        offlineFree: '1 URL of torrent tegelijk',
        offlinePremium: '5 parallelle URL\'s of torrents',
        modesDes: 'Abonnees hebben tweerichtingssynchronisatie en 7 aangepaste opties in éénrichtingssynchronisatie. Incrementele back-upsynchronisatie ondersteund.',
        doubleRealTime:'Verdubbelde realtime synchronisatie',
        doubleRealTimeSyncDes:'Upgrade naar een abonnee en laat twee real-time synchronisatietaken tegelijkertijd uitvoeren.',
        doubledSync: 'Verdubbelde normale synchronisatie',
        doubleSyncDes: 'Upgrade naar een abonnee en laat twee normale taken tegelijkertijd uitvoeren.',
        realTimeSyncing:'Verdubbelde realtime synchronisatie',
        norMalSyncing:'Verdubbelde normale synchronisatie',
        free: 'Vrij',
        premium: 'Premie',
        monthTraffic: '5GB verkeer/maand',
        syncMode: '2 synchronisatiemodi',
        scheduled: 'Geplande overdracht/synchronisatie/back-up',
        scheduledDes: 'Om de planningsfunctie te activeren, moet u upgraden naar de premiumversie.',
        moreTraffic: 'Meer dataverkeer als u dat nodig heeft',
        moreSyncModes: '8 synchronisatiemodi',
        transferSpeed: 'Vervijfvoudigde overdrachtssnelheid',
        doubleSync: 'Dubbele synchronisatie',
        transferServer: 'VIP-overdrachtsserver',
        customerSupport: 'VIP-klantenondersteuning',
        syncSupported: 'Tweerichtingssynchronisatie en 7 aangepaste opties in Eénrichtingssynchronisatie. Spiegelsynchronisatie ondersteund.',
        greatlyIncreased: 'Er zijn 10 threads voor abonnees in plaats van twee, dus de overdrachtssnelheid is aanzienlijk verhoogd.',
        sameTime: 'Abonnees kunnen twee real-time synchronisatietaken en twee normale synchronisatietaken (vier in totaal) tegelijkertijd laten uitvoeren.',
        normalSametime:'Abonnees kunnen tegelijkertijd twee normale synchronisatietaken uitvoeren.',
        automatically: 'Stel een filter in om bestanden met een door de gebruiker gedefinieerde bestandsnaam of bepaalde extensies automatisch over te dragen of te synchroniseren.',
        multipleSync: 'Meerdere synchronisatiedoelen',
        multipleSyncDes: 'Upgrade naar premium om de functie van meerdere synchronisatiedoelen te activeren.',
        freeDes:'Gratis gebruikers hebben in totaal 30GB dataverkeer om elke maand gegevens over te dragen of te synchroniseren tussen cloudopslagdiensten',
        task1: '1 cloud-naar-cloud-taak tegelijk',
        task5: '5 cloud-naar-cloud-taken parallel',
        emailTitle: 'Onvoldoende e-mailconversies',
        emailDes: 'Gratis gebruikers hebben elke maand 50 e-mailconversies, maar het lijkt erop dat u meer nodig heeft dan dat. Upgrade naar premium en u beschikt over onbeperkte e-mailconversies.',
        emailsConversions: '50 e-mailconversies/maand',
        emailsUn: 'Onbeperkte e-mailconversies',
    },
    remindBindEmail:{
        bindExe:'Bind uw e-mailadres om de taak uit te voeren',
        onceBind:' Zodra u uw e-mailadres heeft gebonden, kunt u ook <span class="gift-flow">30GB</span> extra cloud-naar-cloud-dataverkeer ontvangen!',
        bindEmail:'Bind uw e-mailadres in om de kernfuncties van MultCloud te activeren.',
        coreFeatures:'Kernfuncties van Multcloud',
        tourAccount:'Touraccount',
        connectCloud:'Verbind cloudservices met MultCloud',
        viewCloud:'Bekijk alle cloudbestanden via MultCloud',
        uploadFile:'Upload bestanden naar clouds via MultCloud',
        downloadCloud:'Download cloudbestanden via MultCloud',
        syncAndBackup:'Synchroniseer en maak een back-up van bestanden tussen clouds',
        transferFiles:'Breng bestanden over van de ene cloud naar de andere',
        failed:'Kan de bewerking niet uitvoeren. Probeer het later opnieuw.',
    },
    salePagePopup:{
        sOffer:'Speciale aanbieding voor MAANDELIJKS ONBEPERKT',
        timeLimited:'Schiet op, de tijd is beperkt!',
        Hours:'Uur',
        Minutes:'Minuten',
        Seconds:'Seconden',
        monthPrice:'19.9 € / maand',
        dataTra:'voor ONBEPERKT dataverkeer',
        subscribe:'Abonneer nu',
        features:'Functies',
        freePlan:'Gratis abonnement',
        bigSale:'Tijdelijke grote uitverkoop',
        discountsto:'Kortingen tot',
        off:'25% korting',
        premiumPlan:'Premium-abonnement',
        transmit:'Verkeer voor verzending',
        dataTraffic:'Het dataverkeer voor bestandsoverdracht en synchronisatie van cloud naar cloud.',
        originalPrice:'Originele prijs',
        nowOnly:'Nu alleen',
        getDiscount:'Krijg korting',
        moreData:'Meer dataverkeer',
        unlimitedData:'Onbeperkt dataverkeer',
        syncModes:'Synchronisatiemodi',
        syncModesDes:'Abonnees hebben tweerichtingssynchronisatie en 7 aangepaste opties in éénrichtingssynchronisatie. Spiegelsynchronisatie ondersteund.',
        scheduledTran:'Geplande overdracht',
        scheduledTranDes:'Met deze functie kunt u automatische cloud-naar-cloud-taken plannen met een regelmatig interval of voor een speciale timing.',
        transferSpeedDes:'Er zijn 10 threads voor abonnees, in plaats van 2, dus de overdrachtssnelheid is aanzienlijk verhoogd',
        fileEncryption:'Bestandscodering',
        encryptFiles:'Abonnees kunnen bestanden in clouddrives online coderen en bestanden uploaden',
        quarterly:'Per kwartaal',
        yearly:'Jaarlijks',
        monthGb:'150GB / maandelijks',
        monthGbly:'200GB / maandelijks',
        monthfourLy:'400GB / maandelijks',
        unTr:'Onbeperkt verkeer',
        nMonth:'/Maand',
        tQuarter:'/Kwartaal',
        eYear:'/Jaar',
        tOneTime:'Een keer',
        //2021-10-09
        premiumFeatures:'150GB verkeer met alle premiumfuncties gedurende een maand!',
        unlimitedYear:'Een jaar lang onbeperkt verkeer met alle premiumfuncties!',
        unlimitedLiftime:'Onbeperkt verkeer met alle premiumfuncties voor het leven!',

    },
    properties: 'Eigenschappen',
    general: 'Algemeen',
    tips: 'Tips',
    progress: 'Voortgang',
    limits: 'Grenzen van clouddrives',
    detailed: 'Gedetailleerd',
    cancel: 'Verwijder alles',
    simpleSync: 'Eenvoudige synchronisatie',
    onewaySync: 'Synchronisatie in één richting',
    twowaySync: 'Tweerichtingssynchronisatie',
    advancedSync: 'Geavanceerde synchronisatiemodi',
    mirrorSync: 'Spiegelsynchronisatie',
    moveSync: 'Verplaats synchronisatie',
    cmuSync: 'Cumulatieve synchronisatie',
    updateSync: 'Synchronisatie bijwerken',
    increSync: 'Incrementele synchronisatie',
    fullSync: 'Volledige back-upsynchronisatie',
    simpleSyncTip: 'De toegevoegde, gewijzigde en verwijderde bestanden in de bronmap worden gerepliceerd naar de doelmap. De toegevoegde, gewijzigde en verwijderde bestanden in de doelmap worden echter niet gerepliceerd naar de bronmap.',
    mirrorSyncTip: 'De bestanden in de bron- en doelmap zijn altijd hetzelfde (MultCloud verwijdert de extra bestanden in de doelmap).',
    moveSyncTip: 'Zodra de synchronisatie is voltooid, worden alle bestanden in de bronmap verwijderd.',
    cmuSyncTip: 'Wanneer u de bestanden in de bronmap verwijdert, worden dezelfde bestanden in de doelmap niet verwijderd.',
    updateSyncTip: 'Alle bestanden in de doelmap worden eerst verwijderd en vervolgens worden de toegevoegde en gewijzigde bestanden in de bronmap overgebracht naar de doelmap.',
    increSyncTip: 'Telkens wanneer u bestanden synchroniseert, wordt er een submap aangemaakt in de doelmap, zodat de toegevoegde en gewijzigde bestanden in de bronmap ernaar worden overgebracht.',
    fullSyncTip: 'Elke keer dat u bestanden synchroniseert, wordt er een submap aangemaakt in de doelmap, zodat alle bestanden in de bronmap ernaar worden overgebracht.',
    twowaySyncTip: 'De toegevoegde, gewijzigde en verwijderde bestanden in de bronmap worden gerepliceerd naar de doelmap. Op dezelfde manier zullen de toegevoegde, gewijzigde en verwijderde bestanden in de doelmap worden gerepliceerd naar de bronmap (de bestanden in de bron- en doelmap zijn namelijk altijd hetzelfde).',
    syncModes: 'Synchronisatiemodi',
    email: 'E-mail',
    filter: 'Filter',
    thread: 'Thread',
    listThread: 'Aantal doorlopen threads',
    runThread: 'Aantal uitgevoerde threads',
    sameName: 'Dezelfde naam',
    filterInclude: 'Opgenomen extensies (bijv. png, doc, mp4)',
    filterExclude: 'Uit te sluiten bestandsnamen (bijv. target, dist, build)',
    newFilterTag: 'Nieuwe tag',
    createTaskStatus: 'Aangemaakt',
    pendingTaskStatus: 'In afwachting',
    runningTaskStatus: 'Wordt uitgevoerd',
    cancelledTaskStatus: 'Geannuleerd',
    completedTaskStatus: 'Geslaagd',
    failedTaskStatus: 'Mislukt',
    warnTaskStatus: 'Waarschuwing',
    errorTaskStatus: 'Fout',
    warning: 'Waarschuwing',
    logs: 'Logboek',
    once: 'eens',
    daily: 'Dagelijks',
    weekly: 'Wekelijks',
    monthly: 'Maandelijks',
    onlyOnce: 'Slechts één keer uitvoeren op:',
    everyDay: 'Dagelijks draaien op:',
    everyWeek: 'Elke week op:',
    at: 'Bij:',
    sunday: 'Zondag',
    monday: 'Maandag',
    tuesday: 'Dinsdag',
    wednesday: 'Woensdag',
    thursday: 'Donderdag',
    friday: 'Vrijdag',
    saturday: 'Zaterdag',
    runAt: 'Draaien op:',
    lastDay: 'Laatste dag',
    chooseAction: 'Als het doelbestand al bestaat. Kies een actie:',
    optionsPrompt: 'Als bestanden op de bronclouddrive een speciaal teken in de bestandsnaam hebben dat niet is toegestaan op de doelclouddrive, worden de bestanden automatisch hernoemd tijdens het overdrachtsproces en wordt er een log.html-bestand gemaakt in de hoofdmap van de doelclouddrive.',
    sourceNewer: 'Overschrijven als bron nieuwer is.',
    diffSize: 'Overschrijven indien afwijkend formaat.',
    sourceAll: 'Overschrijf indien andere grootte of nieuwere bron.',
    skipFile: 'Sla het bestand over.',
    skipEmail: 'Sla de e-mail over.',
    overWrite: 'Altijd overschrijven.',
    rename: 'Hernoemen',
    overWriteSourceNewer: 'Overschrijf als er een update is van de originele e-mail.',
    deleteAllSource: 'Verwijder alle bronbestanden nadat de overdracht is voltooid.',
    keepFileDate: `Houd de wijzigingsdatum van bestanden bij (ondersteunt Dropbox, Google Drive, G Suite).`,
    automaRename: 'Hernoem automatisch de bestanden die speciale tekens bevatten en genereer een scriptbestand.',
    sendEmail: 'Stuur een e-mailmelding wanneer u deze taak voltooit.',
    sendMessage: 'Stuur een testbericht',
    ignoreFiles: 'Negeer bestanden met deze extensies',
    includeFiles: 'Neem alleen bestanden met deze extensies op',
    selectSync: 'U kunt hier de synchronisatiemodus selecteren:',
    tipsFor: 'Tips voor',
    allTasks: 'Alle taken',
    successful: 'Succesvol',
    unfinished: 'Onvoltooid',
    transferDetails: 'Overdrachtsgegevens',
    redit: 'Opnieuw bewerken',
    publicShare: 'Openbaar delen',
    publicTip: 'Tips:Iedereen die de link ontvangt, kan het bestand bekijken',
    privateShare: 'Privé delen',
    privateTip: 'Tips: Anderen moeten een wachtwoord invoeren om het bestand te bekijken',
    sourceShare: 'Bronaandeel',
    sourceTip: 'Tips:Maak een deellink van de bronclouddrive',
    communityShare: 'Openbaar in MultCloud-community',
    communityTip: 'Tips:Iedereen kan het bestand vinden en bekijken in de MultCloud-community',
    shareSuccess: 'Creëer Share Succesvol',
    copySuccess: 'Kopiëren succesvol',
    sharedYet: "Dit bestand is al gedeeld",
    domain: 'Domein',
    key: 'Sleutel',
    secret: 'Geheim',
    publicShareEasy: 'Iedereen',
    privateShareEasy: 'Privaat',
    communityShareEasy: 'Openbaar',
    sourceShareEasy: 'Bron',
     //2020-10-26-ljm增加
    progressBox:'Voortgang',
    reportPopup: {
        title: 'Rapport delen',
        beforeMsgOne: 'Help ons begrijpen wat er met dit aandeel gebeurt.',
        beforeMsgTwo: 'Hoe zou je het omschrijven?',
        typeItems: {
            spam: 'Spam',
            malwareVirus: 'Malware or virus',
            copyrightViolation: 'Schending van het auteursrecht',
            illegal: 'Illegale inhoud',
            notWorking: 'MultCloud werkt niet goed',
            other: 'Andere ongepaste inhoud',
        },
        nextMsgOne: 'Vul de gegevens over dit rapport in.',
        description: 'Beschrijving',
        nextMsgTwo: 'Beschrijf wat er met het aandeel gebeurt.',
        yourEmail: 'Jouw email',
        nextMsgThree: 'Geef uw e-mailadres op, dan kunnen wij indien nodig contact met u opnemen.',
        submit: 'Indienen',
        back: 'Rug',
        next: 'Volgende',
        messageNone: 'Voer de beschrijving van dit rapport in.',
        emailNone: 'Voer uw e-mailadres voor contact in.',
        success: 'Uw rapport is al naar het MultCloud-team verzonden.'
    },
    subAccountPopup:{
        title: "Beheer van subaccounts",
        titleMax: "Beheer van subaccounts",
        titleDes:"Upgrade naar een abonnee, zodat u subaccounts kunt maken en beheren.",
        tabNameUser: "Gebruikersmodus",
        tabNameItem: "Mapmodus",
        addItemButton: "Map toewijzen",
        users: "Gebruikers",
        folders: "Mappen",
        read: "Lezen",
        write: "Schrijven",
        questionTxtRead: "Gebruikers met een subaccount kunnen in deze map bestanden downloaden, bekijken en kopiëren naar hun clouds.",
        questionTxtWrite: "Gebruikers van subaccounts kunnen nieuwe mappen maken en bestanden in deze map uploaden, verwijderen en hernoemen.",
        userExist:"De gebruiker bestaat al.",
        userSelf:"Je kunt jezelf niet toevoegen als subaccount.",
        quickAssign: "Snel toewijzen",
        quickAdd: "Snel toevoegen",
        allow: "Toestaan",
        batchAddUserNull: "Er is momenteel geen gebruiker toegevoegd.",
        batchAddItemNull: "Er is momenteel geen map toegevoegd.",
        noUserFromAddItem: "Voeg eerst een gebruiker toe.",
        noItemFromAddUser: "Voeg eerst een map toe.",
        addUser: {
            title: "Voeg gebruiker toe",
            radioCreate: "Maak een subaccount aan",
            radioAdd: "Voeg een bestaand MultCloud-account toe",
            createNamePlaceholder: "Maak gebruikersnaam aan",
            createPasswordPlaceholder: "Maak een wachtwoord",
            addNamePlaceholder: "Voer het bestaande MultCloud-account in",
            createNameNone: "Voer een gebruikersnaam in.",
            createNameMore: "De gebruikersnaam moet minder dan 20 tekens lang zijn.",
            createPasswordNone: "Voer een wachtwoord in alstublieft.",
            createPasswordError: "Voer een wachtwoord in met 8-16 tekens.",
            addUserNameNone: "Voer een bestaand MultCloud-account in.",
            addUserNone: "Dit account bestaat niet.",
        },
        addItem: {
            noFolder: "Selecteer een map.",
            exist: "Je hebt de map al toegevoegd.",
        },
        editUser: {
            title: "Sub-account bewerken",
            namePlaceholder: "Vul een gebruikersnaam in",
        },
        cancel: {
            titleUser: "Subaccount verwijderen",
            titleItem: "Map verwijderen",
            msgUser: "Weet u zeker dat u dit account wilt verwijderen?",
            msgItem: "Weet u zeker dat u deze map wilt verwijderen?",
        },
        unknownError: "Kunt u het pad niet vinden, controleer dan of het pad bestaat of voeg de cloud opnieuw toe.",
    },
    verifyPopup: {
        verifyTitle: "Verifieer uw identiteit",
        toRecoveryText: "Ik heb geen van deze",
        verifyEmailTitle: "Controleer je email",
        verifyEmailTips: "We sturen een verificatiecode naar {email}. Om te verifiëren dat dit uw e-mailadres is, voert u dit hieronder in.",
        verifyPhoneTitle: "Verifieer je telefoonnummer",
        verifyPhoneTips: "We sturen een verificatiecode naar {phone}. Om te verifiëren dat dit uw telefoonnummer is, voert u de laatste vier cijfers in, inclusief {last}.",
        verifyPhoneText: "Laatste 4 cijfers van telefoonnummer",
        sendCodeBtn: "Code verzenden",
        enterCode: "Voer code in",
        checkEmailTips: "Als {email} overeenkomt met het alternatieve e-mailadres in uw account, sturen we u een code.",
        checkPhoneTips: "Als {phone} overeenkomt met de laatste vier cijfers van het telefoonnummer in uw account, sturen we u een code.",
        askDevice: "Vraag het mij niet meer op dit apparaat.",
        verify: "Verifiëren",
        recoveryTitile: "Heeft u een accountherstelcode?",
        recoveryTipsOne: "Als u een herstelcode heeft, voert u deze nu in. Heeft u er geen, neem dan contact op",
        recoveryTipsTwo: "Uw herstelcode is 25 tekens lang en ziet er als volgt uit: XXXXX-XXXXX-XXXXX-XXXXX-XXXXX.",
        recoveryCode: "Herstel code",
        recoveryCodeBtn: "Gebruik herstelcode",
        recoveryChangeTitile: "Waarmee kunnen we nog meer uw identiteit verifiëren?",
        recoveryEmailChange: "Voeg een alternatief e-mailadres toe",
        recoveryPhoneChange: "Voeg een telefoonnummer toe",
        enterEmail: "Voer uw e-mailadres in",
        recoveryNextTitle: "Voer de code in die we naar {checkCode} sturen",
        recoveryTipsTitle: "Voor uw veiligheid duurt het vervangen van uw beveiligingsgegevens 30 dagen!",
        recoveryTips1: "Omdat u tweestapsverificatie heeft ingeschakeld, heeft u actuele beveiligingsgegevens nodig om u aan te melden bij uw account.",
        recoveryTips2: "Tijdens de wachtperiode kunt u zich niet met uw account aanmelden bij sites of services, maar wel op apparaten.",
        recoveryTips3: "U kunt het wachten vermijden door:",
        recoveryTips4: "Een vertrouwd apparaat gebruiken.",
        recoveryTips5: "Als u een apparaat heeft waarvoor geen codes nodig zijn, kunt u dit nu gebruiken en uw beveiligingsgegevens bijwerken.",
        recoveryTips6: "Uw beveiligingsgegevens vinden.",
        recoveryTips7: "Is er een kans dat het niet helemaal verloren is? Als u het kunt vinden, kunt u het nu gebruiken om uw account opnieuw in te schakelen.",
        recoveryTips8: "Het wachten maakt het moeilijker voor iemand anders om uw account over te nemen met een gestolen wachtwoord.",
        recoveryPendTitle: "De wijziging van uw beveiligingsgegevens is nog in behandeling",
        recoveryPendTips1: "Op {data} heeft u verzocht om vervanging van uw beveiligingsgegevens",
        recoveryPendTips2: "Actuele beveiligingsinformatie",
        recoveryPendTips3: "Alternatieve e-mail:",
        recoveryPendTips4: "Telefoonnummer:",
        recoveryPendTips5: "Nieuwe beveiligingsinformatie",
        recoveryPendTips6: "Als u uw huidige beveiligingsgegevens wilt behouden,",
        recoveryPendTips7: "annuleer dit verzoek.",
        recoveryCancelTitle: "Hier is uw nieuwe herstelcode",
        recoveryCancelTips1: "Om uw account te beveiligen, heeft u een nieuwe herstelcode nodig.",
        recoveryCancelTips2: "Als u ooit de toegang tot uw account moet herstellen, kan deze code helpen. U moet het opschrijven en op een veilige plaats bewaren. We raden u ten zeerste aan uw herstelcode niet op een apparaat op te slaan.",
        recoveryCancelTips3: "Als u eerder een herstelcode had, is deze niet meer geldig. Gebruik in plaats daarvan deze nieuwe code.",
        recoveryCancelTips4: "Uw nieuwe code is:",
        recoveryCancelSucTitle: "Geweldig! Laten we weer toegang krijgen tot uw account!",
        recoveryCancelSucTips1: "De beveiligingsinformatie-update voor {old} is geannuleerd en u heeft nu volledige toegang tot uw account.",
        recoveryCancelSucTips2: "De contactgegevens die zijn gebruikt om het proces te starten ({new}) zijn verwijderd en worden niet gebruikt als beveiligingsgegevens voor uw account.",
        recoveryCancelSucTips3: "Klik op \"Volgende\" om terug te gaan naar waar u mee bezig was.",
        recoveryCancelErrorTitle: "Aanvraag indienen",
        recoveryCancelErrorTips: "Uw account bevindt zich nog in de wachtperiode.",
        codeText: "Vul je telefoonnummer in",
        exception: {
            emailTwoStringError: "De juiste e-mail begint met \"{errorCode}\".",
            validEmail: "Voer een correct e-mailadres in.",
            phoneLastTwoStringError: "Het juiste nummer eindigt op {errorCode}.",
            validPhone: "U moet de laatste 4 cijfers van het telefoonnummer invoeren.",
            verificationCodeExpired: "De verificatiecode is verlopen.",
            verificationCodeError: "De verificatiecode is onjuist. Controleer de code en probeer het opnieuw.",
            verificationRecoveryCodeExpired: "De code werkt niet. Controleer de code en probeer het opnieuw.",
            verificationCodeNull: "Voer een verificatiecode in.",
        }
    },
    worldBackupPopup: {
        // title:'World Backup Day',
        title:'Speciale MultCloud-aanbieding',
        titleTip:'24-uurs Flash-uitverkoop',
        timerTitle:'Tijdelijke aanbieding eindigt over...',
        getOffer:'Ontvang aanbieding',
        tips100Mo:'100GB / maand verkeersgegevens',
        ps100Mo:'Tips: Het ongebruikte dataverkeer stapelt zich op. Bijvoorbeeld Je hebt de eerste maand slechts 50GB van 100GB verbruikt en de komende maand heb je nog 50GB extra dataverkeer.',
        tips1200Yr:'1200GB / jaar verkeersgegevens',
        ps1200Yr:'Tips: Het ongebruikte dataverkeer stapelt zich op. Bijvoorbeeld Je hebt het eerste jaar slechts 1000GB van 1200GB verbruikt en het jaar daarop heb je nog 200GB extra dataverkeer.',
        tips2400Yr:'2400GB / jaar verkeersgegevens',
        ps2400Yr:'Tips: Het ongebruikte gegevensverkeer zal zich ophopen.  Bijvoorbeeld Je hebt het eerste jaar slechts 2000GB of 2400GB verbruikt en het jaar daarop heb je nog 400GB extra dataverkeer.',
        tipsUnYr:'Onbeperkte verkeersgegevens per jaar',
        psUnYr:'Tips: Een jaar lang onbeperkt dataverkeer!',
        tipsUnLi:'Onbeperkte/Levenslange datalimiet',
        psUnLi:'Tips: Levenslang onbeperkt dataverkeer!',
        tips1:'10 overdraadsessies tegelijk',
        tips2:'Geplande cloudoverdracht',
        tips3:'24/7/365 prioritaire ondersteuning',
        ps1:'Er zijn 10 threads voor abonnees, terwijl 2 voor gratis gebruikers, dus de overdrachtssnelheid is aanzienlijk verhoogd.',
        ps2:'Abonnees kunnen automatische overdracht/synchronisatie van cloud naar cloud plannen met een regelmatig interval of voor een speciale timing.',
        moPrice:'{price} / maand',
    },
    iosPayTipPopup: {
        title: 'Apple-abonnement opzeggen',
        tip: 'Uw huidige {name} heeft de status van automatische verlenging (Apple-transactie-ID: {id}). Annuleer het abonnement hiervoor en probeer het opnieuw.',
        btnTxt: 'Hoe te annuleren',
    },
    appRecommendPopup: {
        title: 'De nieuwe MultCloud mobiele app is nu beschikbaar!',
        tip: 'Download onmiddellijk om gegevens te beheren en over te dragen tussen clouds met mobiele apparaten.',
        modileTitle: 'Download nu de MultCloud mobiele app!',
        iosBtnTitle: 'Downloaden op de',
        iosBtnTip: 'App Winkel',
        androidBtnTitle: 'KRIJG HET AAN',
        androidBtnTip: 'Google Spelen',
        apkBtnTitle: 'Downloaden',
        apkBtnTip: 'MultCloud',
    },
    note: 'Opmerking',
    editCloudNoticPopup: {
        tips: 'De autorisatie is verlopen. Voeg de cloud opnieuw toe aan MultCloud en probeer het opnieuw.',
        btnTxt: 'Opnieuw toevoegen',
    },
    appleTipsPopup: {
        title: 'Tips',
        tipTitle: 'Tips voor 2-factor-authenticatie van iCloud-foto\'s',
        tip1: 'Om uw iCloud-foto\'s met MultCloud te verbinden, moet u MultCloud-servertoegang tot uw Apple ID verlenen. Het kan dus zijn dat onze serverlocatie tijdens de tweefactorauthenticatieprocedure verschilt van uw werkelijke locatie.',
        tip2: 'En onthoud: uw veiligheid en privacy zijn onze nummer 1 prioriteit. MultCloud bewaart uw gegevens niet permanent. Het kan zijn dat een deel van de inhoud tijdelijk in de cache wordt opgeslagen op basis van uw bewerkingen, maar deze wordt onmiddellijk van onze server verwijderd zodra de bewerking is voltooid. En de verbinding tussen uw iCloud-foto\'s en MultCloud-servers gebeurt altijd via een beveiligd 256-bit SSL-kanaal.',
        checkTip: 'Laat dit niet nog een keer zien',
    },
    iCloudDriveTips: {
        title: 'Tips',
        tipTitle: 'Tips voor iCloud Drive 2-factor-authenticatie',
        tip1: 'Om uw iCloud Drive met MultCloud te verbinden, moet u MultCloud-servertoegang tot uw Apple ID verlenen. Het kan dus zijn dat onze serverlocatie tijdens de tweefactorauthenticatieprocedure verschilt van uw werkelijke locatie.',
        tip2: 'En onthoud: uw veiligheid en privacy zijn onze nummer 1 prioriteit. MultCloud bewaart uw gegevens niet permanent. Het kan zijn dat een deel van de inhoud tijdelijk in de cache wordt opgeslagen op basis van uw bewerkingen, maar deze wordt onmiddellijk van onze server verwijderd zodra de bewerking is voltooid. En de verbinding tussen uw iCloud Drive en MultCloud-servers gebeurt altijd via een beveiligd 256-bit SSL-kanaal.',
        checkTip: 'Laat dit niet nog een keer zien', 
    },
    checkApplePopup: {
        title: 'Tweefactorauthenticatie',
        tip1: 'U heeft tweefactorauthenticatie ingeschakeld. Voer de verificatiecode in op uw iPhone/iPad/iPod om door te gaan.',
        tip2: 'Heeft u de verificatiecode niet ontvangen?',
        btn1: 'Bericht versturen...',
        btn2: 'Code nogmaals versturen',
        btn3: 'Sms mij',
        btn4: 'Krijg ondersteuning',
        suc1: 'Er is een bericht met een verificatiecode verzonden naar {num}.',
        suc2: 'Er is een bericht met een verificatiecode naar uw apparaten verzonden.',
        fail1: 'Het verzenden van de verificatiecode is mislukt. Probeer het opnieuw.',
        fail2: 'Voer de verificatiecode in om door te gaan.',
    },
    downloadThreadPopup: {
        title: "Instellingen downloaden",
        tips: "Naam op gedownload bestand",
        defaultNameOne: "E-mails opgeslagen op {date}",
        defaultName: "{num} e-mails opgeslagen op {date}",
        option1: "Bijlagen opslaan",
        option2: "Gespreksformaat",
        option2Tips: "Offertes worden verwijderd wanneer ze worden geactiveerd.",
        option3: "Bewaar alleen het laatste bericht",
    },
    failedFilesPopup: {
        title: 'Mislukte bestanden bekijken: {num}',
        exportExcel: 'Exporteren naar Excel',
        retrySucTip: '{num} items toegevoegd aan de herhalingslijst.',
    },
    viewLogsPopup: {
        title: 'Taakdetails:',
        titleRe: 'Hersteldetails:',
        errorNum: 'Aantal mislukkingen',
        addNum: 'Bestanden toevoegen',
        updateNum: 'Bestanden wijzigen',
        deleteNum: 'Bestanden verwijderen',
        syncSize: 'Sync-grootte',
        syncTime: 'Sync-tijd',
        backupNum: 'Aantal back-ups',
        backupSize: 'Back-up grootte',
        backupTime: 'Back-up tijd',
        restoreNum: 'Aantal herstelacties',
        restoreSize: 'Herstelgrootte',
        restoreTime: 'Hersteltijd',
        tranNum: 'Aantal overdrachten',
        tranSize: 'Overdrachtsgrootte',
        tranTime: 'Overdrachtstijd',
        from: 'Bron:',
        to: 'Doel:',
        executeTime: 'Uitvoeringstijd:',
        sourceAccount: 'Bronaccount',
        targetAccounts: 'Doelaccounts',
        executeResult: 'Uitvoeringsresultaat',
        add: 'Toevoegen:',
        update: 'Bijwerken:',
        delete: 'Verwijderen:',
    },
    taskProgressPopup: {
        title1: 'Je bent een premium gebruiker en hebt nu 10 threads om bestanden gelijktijdig over te dragen.',
        title2: 'Upgrade naar een premium service om maximaal 10 threads te hebben!',
        btnTip: 'Vanaf $9.99',
    },
    subfileSelectPopup: {
        title: 'Selecteer uploadinhoud',
    },
    deleteBatchPopup: {
        tips1: 'Weet u zeker dat u deze <span>{num}</span> taken wilt verwijderen?',
        tips2: 'Taken die zijn verwijderd, kunnen niet worden hersteld.',
    },
    freeSaledPopup: {
        tips1: 'Keep your family\'s memories connected across clouds—claim 10GB FREE this Family Day!',
        tips2: 'Wacht!',
        tips3: 'Looks like you\'re skipping your Family Day gift. Just a reminder: Once skipped, it\'s gone!',
        btns1: 'Claim 10GB',
        btns2: 'Nee, bedankt',
        success: 'Gefeliciteerd! Je hebt zojuist 10GB aan cross-cloud overdrachtsverkeer ontvangen.',
        floatTitle: 'KRIJG 10GB GRATIS',
        popupTitle: 'KRIJG <span>10GB</span> GRATIS',
    }
},
addCloud: {
    connectDesc: 'Selecteer een service om verbinding mee te maken.',
    box: 'Box',
    boxBusiness:'Box for Business',
    dropbox: 'Dropbox',
    google_drive: 'Google Drive',
    google_drive_sharedWithMe: 'Shared with me',
    google_drive_v2: 'Google Drive',
    google_drive_shared_v2: 'Shared with me',
    oneDrive: 'OneDrive',
    oneDriveV2: 'OneDrive',
    sugarSync: 'SugarSync',
    amazonS3: 'Amazon S3',
    iDrivee2: 'IDrive® e2',
    wasabi:'Wasabi',
    webDav: 'WebDAV',
    FTP: 'FTP',
    cloudMe: 'CloudMe',
    cubby: 'Cubby',
    myDrive: 'MyDrive',
    yandex: 'Yandex',
    hiDrive: 'HiDrive',
    WEBDE: 'WEB.DE',
    baiDu: 'BaiDu',
    amazon: 'Amazon',
    alfresco: 'Alfresco',
    aDrive: 'ADrive',
    Icedrive: 'Icedrive',
    NAS: 'NAS',
    oneDrive4Business: 'OneDrive for Business',
    dropbox4Business: 'Dropbox Business',
    pCloud: 'pCloud',
    mega: 'MEGA',
    backblaze: 'Backblaze',
    putio: 'Putio',
    googlePhotos: 'Google Photos',
    googlePhotosV2: 'Google Photos',
    gSuiteSharedDrive: 'Shared Drive',
    evernote: 'Evernote',
    flickr: 'Flickr',
    mediafire: 'MediaFire',
    ownCloud: 'ownCloud',
    mySQL: 'MySQL',
    gSuite: 'Google Workspace',
    gSuiteSharedDrive: 'Shared Drive',
    hubiC: 'hubiC',
    egnyte: 'Egnyte',
    youtube: 'YouTube',
    facebook: 'Facebook',
    picasa: 'Picasa',
    goDaddy: 'goDaddy',
    ubuntu: 'Ubuntu',
    welcomeTo: 'Welcome to MultCloud',
    welcomeFont: 'Now you can easily transfer and manage all your cloud files with one app. First things first, please connect your cloud to MultCloud.',
    peCloud: 'Persoonlijke diensten',
    buCloud: 'Zakelijke diensten',
    sharePointOnline:'SharePoint Online',
    iCloudPhotos: 'iCloud Photos',
    iCloudDrive: 'iCloud Drive',
    continue: 'Continue',
    gmail: 'Gmail',
    comingSoon: 'Coming soon...',
    signInWith: 'Sign in with',
    outlook: 'Outlook',
    fourShared: '4shared',
},
addEmail: {
    connectDesc: 'Klik op de e-mail om deze te verbinden met MultCloud',
    peEmail: 'Selecteer en log in met de e-mail',
    iCloudNotice: 'iCloud Drive kan tijdelijk geen verbinding maken en ons ontwikkelingsteam werkt aan een oplossing voor het probleem.',
    iCloudPhotosNotice: 'iCloud-foto\'s kunnen tijdelijk geen verbinding maken en ons ontwikkelingsteam werkt aan een oplossing voor het probleem.',
},
cloudExploer: {
    uploadFile: 'Upload bestand',
    newFolder: 'Nieuwe map',
    newAlbum: 'Nieuw album',
    search: 'Zoekopdracht',
    grid: 'Rooster',
    pageList: 'Lijst',
    reFresh: 'Vernieuwen',
    modified: 'Gewijzigd op',
    openWith: 'Openen met',
    officeOnline: 'Microsoft OfficeOnline',
    loading: 'Een ogenblik geduld, laden...',
    uploadFolder: 'Map uploaden',
    trash: 'Afval',
    recentlyDeleted: 'Onlangs verwijderd',
    jumpTo: 'Spring naar',
    deleteForever: 'Voor altijd verwijderen',
    restore: 'Herstellen',
    back: 'Rug',
    searchResult: 'Zoekresultaat',
    emptyTrash: 'Lege prullenbak',
    recoverAll: 'Alles herstellenAlles herstellen',
    deleteAll: 'Verwijder alles',
    fileExists: 'Bestand bestaat',
    chooseOption: 'Bestand bestaat, kies een optie!',
    needRestore: 'Als u deze map wilt bekijken, moet u deze vanuit uw prullenbak herstellen',
    limitBoxTip: '1.Een paar clouddrives kunnen enkele beperkingen hebben. Box ondersteunt bijvoorbeeld geen overdracht van een enkel bestand dat groter is dan 2GB. Dergelijke beperkingen worden bepaald door de cloudprovider en kunnen niet door MultCloud worden doorbroken. Voor meer informatie<a href=\"https://www.multcloud.com/help/limitations.html\" target=\"_blank\" class=\"add-cloud-link\">klik hier</a>.<br> 2. Als uw taken na het upgraden naar premium nog steeds geen 10 threads hebben ontvangen, annuleer dan de taken en draag ze opnieuw over. Je taken krijgen 10 threads om over te dragen met exclusieve VIP-servers.',
    fileNameNotEmpty: 'De door u ingevoerde bestandsnaam mag niet leeg zijn.',
    notContainSpecialChar: 'De bestandsnaam mag geen speciale tekens bevatten `/ \ | : * ? \" < >`.',
    CharacterLimit:'De bestandsnaam mag geen speciale tekens bevatten `~\"# %& *: < >？ / \ { | }.`',
    pathNotExist: 'Het pad bestaat niet',
    emptyNotice: 'Deze map is leeg',
    trashEmpty: 'Prullenbak is leeg',
    searchEmpty: 'Zoekresultaten zijn leeg',
    uploadSize: 'De totale grootte van een uploadtaak mag niet groter zijn dan 1GB.',
    simultaneous: 'U kunt maximaal 200 taken tegelijk toevoegen.',
    cancelFailed: 'Annulering mislukt, de taak wordt aangemaakt. Probeer het later opnieuw',
    notWith: 'De bestandsnamen en mapnamen mogen niet beginnen of eindigen met \".\"',
    notUpload: 'upload mislukt.',
    duplicatePhoto: 'Dubbele foto. De foto die u probeert te uploaden is een duplicaat en is niet in uw bibliotheek geïmporteerd.',
    dataLoaded: 'Gegevens geladen',
    sharedDate:'Datum delen',
    failedRestore: 'Het herstellen van het bestand is mislukt omdat de doelmap al een bestand met dezelfde bestandsnaam bevat.',
    //2020-12-11 lijimin
    uploadError:'Het is verboden dit bestand te downloaden (door de officiële cloudservice).',
    downloadLimit: 'Het downloadlimiet voor vandaag is bereikt. Probeer het morgen opnieuw.',
    //2022-4-26 wt
    createBucket:'De bucketnaam mag alleen kleine letters en cijfers bevatten. De lengte moet 3-63 tekens zijn. p.s. De bucketnaam mag niet alleen uit cijfers bestaan (bijvoorbeeld \'12345678\').',
    newBucket:'Nieuwe emmer',
    deleteBucket:'MultCloud kan geen buckets verwijderen met een naamgevingsconventie van alle getallen (d.w.z. \"12345678\").',
    getBucketObjectListFail :'MultCloud kan geen bucket weergeven met een naamgevingsconventie van alle getallen (d.w.z. \"12345678\").',
    newAlubm: 'Nieuw album',
    specialCharError: 'De bestandsnaam mag geen speciale tekens bevatten `/ | : * ? \" < >`.',
},
emailExploer: {
    from: 'Van',
    to: 'Naar',
    cc: 'cc',
    email: 'E-mails',
    subject: 'Onderwerp',
    received: 'Ontvangen',
    sentTime: 'Verstuurd',
    downloadMax200: 'U kunt maximaal 200 e-mails tegelijk downloaden.',
    noSubject: '(geen onderwerp)',
    folderName: {
        Inbox: 'Postvak IN',
        Starred: 'Met ster',
        Snoozed: 'Gesnoozed',
        Sent: 'Verstuurd',
        Drafts: 'Concepten',
        Important: 'Belangrijk',
        Chats: 'Chats',
        Scheduled: 'Gepland',
        AllMail: 'Alle mails',
        Spam: 'Spam',
        Trash: 'Afval',
        Unread: 'Ongelezen',
        Categories_Social: 'Categorieën_Sociaal',
        Categories_Updates: 'Categorieën_Updates',
        Categories_Forums: 'Categorieën_Forums',
        Categories_Promotions: 'Categorieën_Promoties',
        Categories_Personal: 'Categorieën_Persoonlijk',
    }
},
imageSaver: {
    analyzing: 'Analyseren',
    failedToParse: 'Parseren mislukt',
    noviceGuidance: 'Hier kun je alle recent geüploade afbeeldingen/video\'s naar de cloud of verpakte afbeeldingen/video\'s voor Instagram bekijken.',
    insDownloadExist: 'U heeft dit profiel al gedownload. U kunt het vinden in de sectie "Takenlijst".',
    taskExpiredOn: 'Verlopen op {time}',
    taskStoringTill: 'Opslag tot {time}',
    taskPart: 'Deel',
    taskUnitFile: 'bestand',
    taskUnitFiles: 'bestanden',
    taskQueue: 'In de wachtrij',
    taskTabUpload: 'Uploaden',
    taskTabSaveAll: 'Alles opslaan in de cloud',
    taskTabDownload: 'Alles downloaden van IG',
    downloadInsVideo: 'Download de video',
    downloadSinglePost: 'Download het hele bericht',
    downloadAllPosts: 'Download alle berichten',
    downloadAllReels: 'Download alle Reels',
    downloadAllStories: 'Download alle verhalen',
    downloadAllHighlights: 'Download alle hoogtepunten',
    saveInsVideo: 'Sla de video op in de cloud',
    saveSinglePost: 'Sla het hele bericht op in de cloud',
    saveAllPosts: 'Sla alle berichten op in de cloud',
    saveAllReels: 'Sla alle Reels op in de cloud',
    saveAllStories: 'Sla alle verhalen op in de cloud',
    saveAllHighlights: 'Sla alle hoogtepunten op in de cloud',
    insCardPosts: 'berichten',
    insCardFollowers: 'volgers',
    insCardFollowing: 'volgend',
    insTabPosts: 'Foto\'s en Video\'s',
    insTabReels: 'Reels',
    insTabStories: 'Verhalen',
    insTabHighlights: 'Hoogtepunten',
    insBlankText: 'Met MultCloud\'s Instagram Downloader kun je moeiteloos Instagram-posts, reels, stories en highlights downloaden en opslaan, zodat je je favoriete inhoud op elk moment kunt beheren.',
    webGoogleBlankText: 'Verzamel moeiteloos afbeeldingen van elke website of Google-zoekopdracht en sla ze direct op in je cloud- of lokale opslag.',
    noTask: 'Geen taken',
    inputTipHttp: 'Voer een website-URL of een Google-zoekwoord in',
    fetchBtn: 'Nu ophalen',
    fetchingBtn: 'Aan het ophalen...',
    loadMore: 'Meer laden',
    downloadAll: 'Download alles',
    saveAll: 'Alles opslaan in de cloud',
    saveToCloud: 'Opslaan in de Cloud',
    clearHistory: 'Geschiedenis wissen',
    cancel: 'Annuleren',
    retry: 'Opnieuw proberen',
    view: 'Bekijken',
    noImage: 'Geen inhoud gevonden',
    notSupport: 'Misschien wordt deze URL niet ondersteund. Controleer de URL en probeer het opnieuw.',
    inputTipIns: 'Voer een Instagram-URL in',
    post: 'berichten',
    posts: 'berichten',
    uploadTo: 'Uploaden naar: ',
    download: 'Downloaden',
    uploading: 'Aan het uploaden',
    finished: 'Gereed',
    all: 'Alle',
    videoInputTip: 'Plak hier de link naar je video',
    videoTip: `Download hoogwaardige video's van YouTube, Facebook, X en meer dan <a href="https://www.multcloud.com/help/video-downloader.html" target="_blank" style="text-decoration: underline;color: #5562B4;">1000 andere websites</a> 
    met MultCloud's advertentievrije, cross-platform Online Video Downloader—geen installatie vereist.`,
    process: 'Bezig met verwerken...',
    thumbnail: 'Omslagafbeelding',
    abrTypeVeryHigh: 'Zeer Hoog',
    abrTypeHigh: 'Hoog',
    abrTypeNormal: 'Normaal',
    abrTypeLow: 'Laag',
    default: 'Standaard',
    generat: 'Bestand maken',
    retryTip: 'De taak is opnieuw gestart. U kunt de nieuwste voortgang bekijken onder het tabblad "Alles".',
},
taskList: {
    taskListDes: 'U kunt hier taken voor cloudoverdracht, cloudsynchronisatie en het opslaan van gedeelde bestanden beheren',
    multiCloudSync: 'Synchronisatie van meerdere wolken',
    MultiCloudTransfer: 'Overdracht van meerdere clouds',
    nextTransfer: 'Volgende overdracht',
    scheduled: 'Gepland',
    nextSync: 'Volgende synchronisatie',
    reTransfer: 'Opnieuw overboeken',
    saveNow: 'Nu opslaan',
    transferTasks: 'taken overdragen',
    syncTasks: 'Synchroniseer taken',
    shareTasks: 'Deel taken',
    backupTasks: 'Back-uptaken',
    emailTransferTasks: 'Taken voor e-mailmigratie',
    allTime: 'Altijd',
    today: 'Vandaag',
    latestWeek: 'Laatste week',
    latestMonth: 'Laatste maand',
    customDate: 'Aangepaste datum',
    allStatus: 'Alle status',
    preset: 'Vooraf ingesteld',
    noTaskCreated: 'Er is geen taak aangemaakt',
    createTransferTask: 'Maak een overdrachtstaak',
    createSyncTask: 'Maak een synchronisatietaak',
    createRemoteTask: 'Maak een taak op afstand',
    timeMustLess: 'De starttijd moet kleiner zijn dan of gelijk zijn aan de eindtijd',
    taskNameRule: 'De taaknaam mag niet langer zijn dan 200 tekens',
    backupTaskNameRule: 'De taaknaam mag niet langer zijn dan 255 tekens',
    detailNote: 'Deze taak is nog in voorbereiding en er is geen gedetailleerde voortgang te zien.',
    notTraffic: 'Niet genoeg dataverkeer voor transmissie van cloud naar cloud',
    reSync:'Opnieuw synchroniseren',
    rebackup:'Maak opnieuw een back-up',
    rerestore:'Opnieuw herstellen',
    //2021-10-11
    createBackupTask:'Maak een back-uptaak',
    createTeamTransferTask:'Maak een teamoverdrachtstaak',
    multiClouds: 'Multi-cloud',
    speedUP: 'Versnellen',
    noTasks: 'Geen taken',
    noTasksTip: 'Start je eerste taak en ontvang naadloze cloud-naar-cloud overdracht en synchronisatie.',
    loadingTip: 'Een moment geduld alstublieft.',
    allTasks: 'Alle taken ({num})',
},
cloudTransfer: {
    transferDescription: 'Maak een overdrachtstaak om bestanden over te dragen tussen clouddrives',
    transferOperateFrom: 'Klik hier om de clouddrives of mappen te selecteren waarvan u wilt overbrengen',
    from: 'VAN',
    to: 'naar',
    transferOperateTo: 'Klik hier om de clouddrive of map te selecteren waarnaar u wilt overbrengen',
    transferNow: 'Nu overboeken',
    transfer: 'Overdracht',
    addTaskOnly: 'Alleen taak toevoegen',
    addTaskNow: 'Taak toevoegen en nu overdragen',
    addSyncTaskNow: 'Taak toevoegen en nu synchroniseren',
    addBackupTaskNow:'Taak en back-up nu toevoegen',
    transferSucces: 'Overdracht succesvol',
    sureContinue: 'U heeft meer dan 10 bronitems geselecteerd en elk bronitem correspondeert met een e-mailmelding. Dat betekent dat u mogelijk meer dan 10 e-mailmeldingen ontvangt. Weet je zeker dat je doorgaat?',
    sure: 'Ja, dat weet ik zeker.',
    //2020-10-29ljm新增
    sourceRemind:'Het maximale aantal bronitems is 200. Selecteer minder items of selecteer een hele map. P.S. Een hele map telt slechts één item.',
    backupSourceRemind:'Het maximale aantal bronitems is 1000. Selecteer minder items of selecteer een hele map. P.S. Een hele map telt slechts één item.'
},
cloudSync: {
    syncDescription: 'Maak een synchronisatietaak om bestanden tussen clouddrives te synchroniseren',
    syncOperateTo: 'Klik hier om de clouddrives of mappen te selecteren waarmee u wilt synchroniseren',
    syncOperateFrom: 'Klik hier om de clouddrive of map te selecteren waarvan u wilt synchroniseren',
    syncNow: 'Synchroniseer nu',
    taskEmpty: 'Taaknaam mag niet leeg zijn.',
    //2020-10-29ljm新增
    aimRemind:'Het maximale aantal doelmappen is 200.',
    realTimeSync:'Realtime synchronisatie',
    normalSync:'Normale synchronisatie',
    pause:'Pauze',
    paused:'Gepauzeerd',
    swicthTwoWay:'Schakel over naar tweerichtingssynchronisatie',
    switchOneWay:'Schakel over naar eenrichtingssynchronisatie',
    fristSync:'Eerste synchronisatie',
    lastSync:'Laatste synchronisatie',
    initSync:'De eerste synchronisatie van de gegevens is nog bezig, wacht alstublieft.',
    realSyncing:'Realtime synchroniseren...',
    servicesSu:'Cloudservices ondersteund voor realtime synchronisatie',
    addRealDrives:'U moet een clouddrive toevoegen die realtime synchronisatie ondersteunt.',
    egDrives:'Voorlopig worden alleen Google Drive, Dropbox, Dropbox Business, OneDrive, OneDrive for Business, G Suite en box ondersteund voor realtime synchronisatie.',
    initTial:'Initialiseren',
    realSync:'Realtime synchronisatie',
    createdAt:'Aangemaakt bij',
    oneWaySimple:'Eenrichtings(eenvoudige synchronisatie)',
    twoWay:'Tweerichtings(Binnenkort beschikbaar...)',
    gooleFolder:'Het wordt niet gesynchroniseerd als er alleen wijzigingen zijn in submappen van een Google Drive-map.',
    realTimeNotice:'U kunt maximaal twee realtime synchronisatietaken tegelijkertijd uitvoeren, dus sommige van uw subtaken worden gepauzeerd. Weet je zeker dat je doorgaat?',
    reachMax:'U heeft het maximale aantal logs bereikt, alleen de nieuwste logs worden getoond.',
    notRun:'De taak is niet aan het rennen.',
    bePaused:'Als de real-time synchronisatie taak langer dan 7 dagen niet actief blijft, wordt de taak automatisch gepauzeerd.',
    dontShow:'Laat dit niet meer zien',
    timeOut:'Traverse timeout',
    outMostly:'Er is een time-out opgetreden bij Traverse omdat er te veel bestanden of te veel submappen zijn voor realtime synchronisatie. We raden u aan in plaats daarvan een normale synchronisatietaak te maken.'
},
emailTransfer: {
    cloudEmail: 'E-mailmigratie',
    description: 'Migreer uw e-mail naar de cloud als PDF.',
    migrationSetting: 'Migratie-instellingen',
    cutSetting: 'Snij-instellingen',
    copySetting: 'Kopieer instellingen',
    settingTips: 'Instelling voor de overdracht',
    notification: 'Kennisgeving',
    watermark: 'Watermerk',
    delWatermark: 'Verwijder de watermerken uit e-mails die als PDF zijn gedownload',
    saveAtt: 'Bijlagen opslaan',
    converFormat: 'Gespreksformaat',
    converFormatTip: 'Offertes worden verwijderd wanneer ze worden geactiveerd.',
    saveOnly: 'Bewaar alleen het laatste bericht',
    optionTitle: 'Sommige e-mails bestaan al. Wat zou je willen doen?',
    filterTitle: 'U kunt een extra filter voor FROM-selectie opgeven.',
    filterMessage: 'Voer e-mailadressen in en scheid ze met een komma',
    filterOption1: 'Overschrijf het als het gesprek is bijgewerkt',
    filterOption2: 'Altijd overslaan',
    filterOption3: 'Altijd hernoemen',
    filterOption4: 'Heeft bijlage',
    filterOption5: 'Is ongelezen',
    transferNow: 'Migreer nu',
    filterDateOptions1: 'Elk moment',
    filterDateOptions2: 'Ouder dan een week',
    filterDateOptions3: 'Ouder dan een maand',
    filterDateOptions4: 'Ouder dan 6 maanden',
    filterDateOptions5: 'Ouder dan een jaar',
    filterDateOptions6: 'Aangepast bereik...',
    showMore: 'laat meer zien',
    startDate: 'Begin datum',
    endDate: 'Einddatum',
},
exception: {
    exceedMaxLimit: 'Het aantal aanvragen overschreed het maximum.',
    cloudNameExist: 'Deze weergavenaam bestaat al. Voer een andere in.',
    pathNotFound: 'Controleer of het bestand of de map op het opgegeven pad bestaat.',
    notBeTheSame: 'De bronmap en doelmap kunnen niet hetzelfde zijn.',
    notTransferring: 'Deze map kan niet worden geselecteerd voor het overbrengen van bestanden. Selecteer de submappen of andere mappen.',
    verifyCodeInvalid: 'Fout in verificatiecode.',
    nameEmpty: 'De weergavenaam kan niet leeg zijn',
    emailEmpty: 'E-mail kan niet leeg zijn',
    serverEmpty: 'Server kan niet leeg zijn',
    usernameEmpty: 'Gebruikersnaam kan niet leeg zijn',
    passwordEmpty: 'Wachtwoord kan niet leeg zijn',
    domainEmpty: 'Domein kan niet leeg zijn',
    bucketNameEmpty: 'Bucketnaam kan niet leeg zijn',
    accessKeyEmpty: 'Access Key ID kan niet leeg zijn',
    secretAccessKeyEmpty: 'Geheime toegangssleutel kan niet leeg zijn',
    keyIdEmpty: 'keyID kan niet leeg zijn',
    applicationKeyEmpty: 'applicatieKey kan niet leeg zijn',
    onlyAlbum: 'Alleen albummappen die door MultCloud zijn gemaakt of gedeeld, kunnen worden geselecteerd voor het opslaan van afbeeldingen, video\'s en andere mediabestanden.',
    parametersNotEmpty: 'De parameters mogen niet leeg zijn.',
    notMediaFiles: 'Opmerking: in de map \"Albums\" kunnen alleen albummappen worden opgeslagen, maar geen mediabestanden.',
    notStoreDirectories: 'De map \"Foto\'s\" kan geen mappen opslaan.',
    onlyStoreImages: 'Opmerking: in de map "Foto\'s" kunnen alleen afbeeldingen, video\'s en andere mediabestanden worden opgeslagen, maar geen mappen',
    //400 云盘管理
    unknownError: 'De verbinding met deze service is mislukt. Autoriseer de toegang van MultCloud tot de service opnieuw.',
    addCloudFailed: 'Sommige parameters zijn niet correct ingevoerd.',
    renameCloudFailed: 'Mislukt de naam van de cloud niet wijzigen. Probeer het later opnieuw.',
    deleteCloudFailed: 'Mislukt de cloud niet verwijderen. Probeer het later opnieuw.',
    invalidCloudAccount: 'Dit cloudaccount bestaat niet.',
    //邮件管路
    bindEmailFail: 'Mislukt om e-mail te binden.',
    linkHasExpired: 'De link is verlopen.',
    //文件管理
    listItemsFailed: 'Mislukt bestanden weergeven, voeg de cloud opnieuw toe aan MultCloud.',
    deleteItemFailed: 'Mislukt om item te verwijderen.',
    renameItemFailed: 'Mislukt om item te hernoemen.',
    createFolderFailed: 'Mislukt om map te maken.',
    moveItemFailed: 'Mislukt om item te verplaatsen.',
    shareItemFailed: 'Mislukt om item te delen.',
    uploadFailed: 'Bestandsgegevens niet gevonden.',
    toFolderIdBlanked: 'Het \"getijde\" is blanco',
    downloadFileFailed: 'Mislukt om het bestand te downloaden, vernieuw de pagina of voeg de cloud opnieuw toe aan MultCloud.',
    //任务管理
    addTaskFail: 'Mislukt om taak toe te voegen.',
    taskQuotaLimit: 'Je hebt het maximale aantal van 200 cloud-naar-cloud overdrachttaken bereikt, verwijder alstublieft enkele onbelangrijke taken.',
    deleteTaskFail: 'Mislukt om taak te verwijderen.',
    maxRunningLimit: 'De lopende taak overschrijdt het maximale aantal en deze taak kan worden toegevoegd als wachtend.',
    userCreateFail: 'Mislukt om gebruiker aan te maken, probeer het later opnieuw.',
    userUpdateFail: 'Mislukt om accountinformatie aan te passen, vernieuw de pagina en probeer het opnieuw.',
    createSaltFail: 'Mislukt om zout te creëren, probeer het opnieuw.',
    listFolderFailed: 'Mislukt om de map weer te geven, probeer de cloud opnieuw toe te voegen.',
    //401
    cloudCategoryInvalid: 'De cloudservice wordt niet meer ondersteund.',
    executeTaskFail: 'Mislukt om taak uit te voeren, controleer alstublieft uw internetverbinding.',
    parameterInvalid: 'De parameters zijn ongeldig.',
    saltInvalid: 'Your session has expired, please log in again.',
    emailInvalid: 'Het is geen geldig e-mailadres.',
    notAuthorized: 'De gebruikersnaam of het wachtwoord is niet correct.',
    //403
    cloudNameEmpty: 'De weergavenaam mag niet leeg zijn.',
    addCloudExpired: 'Mislukt om cloud toe te voegen, voeg de cloudservice opnieuw toe.',
    verifyCodeInvalid: 'De verificatiecode is ongeldig.',
    emailExist: 'De verificatiecode is ongeldig.',
    exceedMaxLimit: 'De verzoeken overschrijden het maximale aantal.',
    userIdNotNull: 'Het gebruikers-ID is leeg.',
    //404
    notFoundTask: 'De taak is niet gevonden.',
    noTaskRunning: 'Er wordt geen taak uitgevoerd',
    userNotFound: 'De gebruiker wordt niet gevonden.',
    loginerNotFound: 'De inlogger wordt niet ondersteund.',
    deletePermissionLimited:'Je kunt deze bewerking niet uitvoeren, omdat je geen \"Verwijdermachtiging\" hebt.',
    notHaveDeletePermission: 'Je hebt geen toestemming om het bestand/de map te verwijderen.',
    uploadPermissionLimited:'Je kunt deze bewerking niet uitvoeren omdat je geen \"Uploadmachtiging\" hebt.',
    movePermissionLimited:'Je kunt deze bewerking niet uitvoeren omdat je geen \"toestemming om te verplaatsen\" hebt.',
    copyPermissionLimited:'Je kunt deze bewerking niet uitvoeren omdat je geen \"toestemming om te kopiëren\" hebt.',
    notHavePermission:'Vanwege het ontbreken van schrijfmachtigingen, kun je dit bestand/map niet plakken.',
    cutPermissionLimited:'Je hebt geen toestemming om dit bestand/map te knippen en te plakken.',
    mkdirPermissionLimited:'Je kunt deze bewerking niet uitvoeren omdat je geen \"Machtiging om map te maken\" hebt.',
    notCreatPermission: 'Je kunt geen bucket of map maken vanwege het ontbreken van schrijfmachtigingen of onvoldoende ruimte.',
    creatIDriveFolderError: 'De objectnaam bevat niet-ondersteunde tekens.',
    creatIDriveFolderToLong: 'Mapnaam mag niet meer dan 245 tekens bevatten.',
    noUploadPermission: 'Vanwege het ontbreken van uploadmachtigingen of onvoldoende opslagruimte in de cloud, kun je dit bestand niet uploaden.',
    bucketNameLongError:'De naam van de bucket moet tussen 3 en 63 tekens lang zijn, gebruik alleen kleine letters, cijfers, punten (.), en streepjes (-), begin en eindig met een letter of cijfer, en vermijd opeenvolgende punten.',
    bucketNameIsNotIp: 'De naam van de bucket kan geen IP-adres zijn.',
    renamePermissionLimited:'Je kunt deze bewerking niet uitvoeren omdat je geen \"Hernoemmachtiging\" hebt.',
    downloadPermissionLimited:'Je kunt deze bewerking niet uitvoeren omdat je geen \"Downloadmachtiging\" hebt.',
    ipNotFound: 'Het IP-adres is niet gevonden.',
    sugarSyncWarn: 'Het is niet ondersteund om de map te selecteren. Selecteer alstublieft de map \"Webarchief\", \"Magische koffer\", \"Mobiele foto\'s\", de submappen daarvan of andere mappen.',
    flickWarn: 'Het is niet ondersteund om de map te selecteren. Selecteer alstublieft de map \"/Albums\", de submappen daarvan of andere mappen.',
    baiDuWarn: 'Het is niet ondersteund om de map te selecteren. Selecteer alstublieft de map \"Alle bestanden/Mijn app-gegevens/Multcloud\", de submappen daarvan of andere mappen.',
    dropBoxbusinessWarn: 'It is not supported to select root directory, please select the other directories.',
    createFolderFail: 'Mislukt om de map te maken.',
    //mega报错
    addMegaFailed: 'Sommige parameters zijn niet correct ingevoerd of je hebt F2A geactiveerd.',
    //mySql报错
    mySqlWarn:'Deze cloud kan niet worden geselecteerd als het doel van cloud-naar-cloud overdracht.',
    //2020-10-29ljm新增
    maxTaskRemind:'Je hebt het maximale aantal van 5000 cloud overdracht/synchronisatie taken bereikt. Verwijder alsjeblieft wat onnodige taken en probeer het opnieuw. PS: Als er 3 bronnen zijn in een overdrachtstaak, telt de overdrachtstaak als 3 taken.',
    // 2020-11-25 yjs
    torrentTort:'Deze inhoud is ongeautoriseerd of inbreukmakend gekopieerd.',
    //2020-12-4 xth
    shareNotUpload:'De eigenaar heeft de toestemming voor \"uploaden toestaan\" geannuleerd, vernieuw de pagina alstublieft.',
    //2020-12-9 xth
    shareItemUpdate:'De eigenaar heeft de toestemming van deze deellink gewijzigd, vernieuw de pagina alstublieft.',
    nameLong:'Gebruikersnaam is te lang (maximaal 20 tekens). Uw gebruikersnaam is langer dan 20 tekens.',
    notPermission:'Dit is een teambestand en je hebt geen toestemming om deze bewerking uit te voeren.',
    notOpened:'Deze cloud ondersteunt geen real-time synchronisatie.',
    taskNotFound:'De taak bestaat niet.',
    subscribeFail:'Mislukt om taak te maken.',
    driveAccountIdInvalid:'Kan de realtime synchronisatietaak niet maken. Verwijder alstublieft de geselecteerde cloudservices en voeg ze opnieuw toe en probeer het opnieuw.',
    unknownState:'Kan deze bewerking niet uitvoeren, probeer het later opnieuw.',
    InvalidParameter:'Ongeldige parameter.',
    InvalidDirectory:'De hoofdmap van box ondersteunt deze functie niet.',
    HasExist:'De onmiddellijke synchronisatietaak voor deze map bestaat al. Annuleer de onmiddellijke synchronisatietaak voor deze map en maak deze opnieuw in de map',
    // taskRunningNumberLimited:'You can run 5 cloud-to-cloud tasks in parallel, please cancel a running task and try again.',
    taskRunningNumberLimited:'Er zijn al twee realtime synchronisatietaken in actieve status. Pauzeer eerst een realtime synchronisatietaak',
    reachedLimit:'U heeft de snelheidslimiet van deze cloud bereikt. Probeer het later opnieuw.',
    selectAlbumWarn:'Opmerking: in een albummap kunnen alleen afbeeldingen, video\'s en andere mediabestanden worden opgeslagen, maar geen mappen',
    notSupported:'Real-time synchronisatie wordt momenteel niet ondersteund voor taken met meerdere doelen.',
    incorrectFormat:'Sorry, uw telefoonnummernotatie is onjuist.',
    taskMaximumNumberLimited:'U heeft het maximale aantal van 200 realtime synchronisatietaken bereikt. Verwijder enkele onnodige realtime synchronisatietaken en probeer het opnieuw.',
    autoLoginFail: 'U heeft tweestapsverificatie geactiveerd. Log opnieuw in.',
    unsubscribeFail:'uitschrijven mislukt',
    //云盘操作报错
    alreadyAdd:'Je hebt de clouddrive al toegevoegd.',
    toggleWhileEditing:'Het account dat u heeft toegevoegd, komt niet overeen met het huidige account.',
    //2022-4-25 wt
    emptyBucket:'U kunt geen buckets verwijderen die niet leeg zijn. P.S. Zorg ervoor dat er ook geen objecten aanwezig zijn in de bucketversie van Wasabi.',
    cannotCopyFolder:'U kunt een map niet naar dezelfde bucket kopiëren.',
    cannotCopyIdrivee2Folder: 'Mappen onder hetzelfde IDrive e2-account kunnen niet naar elkaar worden gekopieerd.',
    cannotCutFolder: 'Mappen onder dezelfde bucket kunnen niet aan elkaar worden geknipt en geplakt.',
    bucketAlreadyExists:'De gevraagde bucketnaam is niet beschikbaar. De bucketnaamruimte wordt gedeeld door alle gebruikers van het systeem. Selecteer een andere naam en probeer het opnieuw.',
    accessPermissionLimited:'U heeft geen toestemming om deze map te openen.',
    accessDenied:'Toegang geweigerd, u bent niet bevoegd om deze handeling uit te voeren.',
    shareTransferCanotCopy: 'Het kopiëren van de hoofdmap van een share met meerdere items wordt momenteel niet ondersteund.',
    // 2022-6-8 wt 
    sharePointOnlineNotTrans:'De SharePoint-hoofdmap kan niet worden geselecteerd voor het overbrengen van bestanden. Selecteer een submap van een site.',
    sharePointListFailed:'Fout 500 - Interne Server Fout. Tips: Controleer of dit account toegang heeft tot de SharePoint-service.',
    sameDirError: 'De bronaccount en de doelaccount mogen niet hetzelfde zijn.',
    //iCloudPhotos报错
    onlySaveAlbums: 'Opmerking: in de doelmap die u selecteert, kunnen alleen albums (mappen) worden opgeslagen.',
    notSelectICloudPhotosRoot: 'Opmerking: in de hoofdmap van iCloud-foto\'s kunnen alleen albums (mappen) worden opgeslagen.',
    notSelectICloudPhotosForder: 'Opmerking: De map die u selecteert, kan alleen albumkappen (mappen) opslaan.',
    notSelectICloudPhotosAlbum: 'Opmerking: in de doelmap die u selecteert, kunnen alleen afbeeldingen worden opgeslagen (mappen niet beschikbaar).',
    notSelectICloudPhotosOther: 'Opmerking: de doelmap die u selecteert, kan afbeeldingen niet rechtstreeks opslaan; alle overgebrachte afbeeldingen worden opgeslagen in de map \"Recent\".',
    notSelectICloudPhotosBackup: 'iCloud-foto\'s kunnen niet worden geselecteerd als doel voor \"Cloud Backup\". Om afbeeldingen in iCloud-foto\'s op te slaan, selecteert u \"Cloudoverdracht\" of \"Cloudsynchronisatie\".',
    notSelectICloudPhotosSyncRoot: 'Opmerking: Afbeeldingen kunnen niet worden gesynchroniseerd met de hoofdmap van iCloud-foto\'s.',
    notSelectICloudPhotosSync: 'Dit is een map in iCloud-foto\'s. U kunt alleen afbeeldingen synchroniseren met albums in iCloud-foto\'s.',
    sendTooMany: 'Er zijn te veel verificatiecodes verzonden. Voer de laatst ontvangen code in, gebruik een van uw apparaten of probeer het later opnieuw.',
    verifySecurityCodeFailed: 'Kan niet verifiëren. Controleer de verificatiecode en voer deze opnieuw in',
    appleNotEnablePhotos: 'iCloud-foto\'s is momenteel niet beschikbaar voor uw Apple ID. Om iCloud-foto\'s te gebruiken, logt u in met de Apple ID op een Apple-apparaat en probeert u het opnieuw.',
    tooManyRequests429: 'Gebruikerslimiet overschreden. Probeer het opnieuw na {date}.',
    tooManyRequests403: 'Te veel verzoeken tegelijkertijd. Probeer het later opnieuw.',
    // iCloudDrive报错
    folderNameIsTooLong: 'De mapnaam mag niet langer zijn dan 255 tekens.',
    fileNameIsTooLong: 'De bestandsnaam mag niet langer zijn dan 250 tekens.',
    iCloudDriveNotEnoughSpace: 'Onvoldoende ruimte om het bestand te uploaden.',
    uploadFileIsTooBig: 'Het bestand is te groot om te uploaden. MultCloud beperkt uploads momenteel tot maximaal 100 MB.',
    uploudFileSizeIsZero: 'Het is niet mogelijk om nulbytebestanden naar iCloud Drive te uploaden.',
    notUploudSpecialFile: 'Kan dit type bestand niet uploaden naar deze app-bibliotheek.',
    notRenameApp: 'Apple staat niet toe dat de app-mappen, zoals Pages, Numbers en Keynote, worden hernoemd.',
    ErrorDeleteDistinguishedFolder: 'Specifieke mappen kunnen niet worden verwijderd.',
    moreThan256Characters: 'De mapnaam mag niet langer zijn dan 256 tekens.',
    cloudNotFound: 'De cloud is verwijderd.',
    fourSharedUnauthorized:'Uw 4shared-machtiging is verlopen. Autoriseer uw account opnieuw door op \'Opnieuw toevoegen\' te klikken.',
    fileFolderNameLengthExceed:"De bestands-/mapnaam mag niet langer zijn dan 255 tekens.",
    invalidLink: 'Ongeldige link.',
    requestFailed: 'De aanvraag is niet gelukt.',
    exceeds2GB: 'De bestandsgrootte overschrijdt 2 GB en kan niet worden gedownload.',
    licenseUpgradError: 'De licentie is niet beschikbaar omdat u een {scheme} abonnee bent',
    noLicenseCode: 'Voer een licentiecode in',
    licenseCodeError: 'De licentiecode die u hebt ingevoerd is onjuist',
},
preview: {
    fileNotReview: 'bestanden kunnen niet worden beoordeeld',
    goOringinalSite: 'Ga naar de originele site'
},
remoteTask: {
    remoteTask: 'Taak op afstand',
    createTask: 'Taak maken',
    successsExceed: 'Link gekopieerd!',
    operateSuccess: 'Operatie succes',
    noRemote: 'Er is geen externe taak gemaakt',
    unKnownError: 'Een onbekende fout',
    undefinedDisk:"Kunt u de doelmap niet vinden, kopieer dan de downloadlink en maak een nieuwe externe uploadtaak.",
    taskExpired:'Het is verlopen. Probeer het opnieuw',
    createDescribe:'Breng bestanden van links, torrents en magneten rechtstreeks over naar uw clouds.',
    saveURLDescribe:'Bewaar bestanden van URL-links rechtstreeks naar uw clouds.',
    noSelectFile: 'Selecteer een bestand',
    excuteNow:'Voer nu uit',
    maxLimit:'Het aantal externe taken mag niet groter zijn dan 1000. Verwijder enkele onbelangrijke taken.',
    noSeeds:'Weinig middelen',
    failedToParse:'Parsen mislukt',
    parseMagnetRunning:'Parse zaden, wacht alsjeblieft...',
    selectedFileLimit:'Het aantal geselecteerde bestanden mag niet groter zijn dan 500 en de totale grootte mag niet groter zijn dan 50GB.',
    addLink: 'Link toevoegen',
    startEmailSend: 'E-mailmelding sturen bij taakvoltooiing',
    nowUpload: 'Nu uploaden',
},
shares: {
    myShares: 'Mijn aandelen',
    savedShares: 'Opgeslagen aandelen',
    sharedOn: 'Gedeeld op',
    allowedTo: 'Upload toestaan',
    location: 'Locatie',
    shareNull: 'Je hebt nog geen bestand gedeeld.',
    shareNullTips: 'Tips: Om een bestand te delen, kunt u met de rechtermuisknop op het bestand klikken en de optie \"Delen\" selecteren.',
    savedShareNull: 'Je hebt nog geen gedeeld bestand opgeslagen.',
    savedShareNullTips: 'Tips: als iemand een deellink met u deelt, kunt u deze hier opslaan zodat u er snel toegang toe heeft.',
},
login: {
    experienceSigning: 'Ervaar zonder te ondertekenen',
    forgotPassword: 'Wachtwoord vergeten?',
    signIn: 'Aanmelden',
    rememberMe: 'Onthoud me',
    keepLogin: 'Hou me ingelogd',
    loginWith: 'Login met',
    email: 'E-mail',
    password: 'Wachtwoord',
    verificationCode: 'Verificatie code',
    firstName: 'Voornaam',
    lastName: 'Achternaam',
    confirmPassword: 'bevestig wachtwoord',
    createAccount: 'Account aanmaken',
    continueWith: ' of doorgaan met',
    resetMessage: 'Resetbericht verzenden',
    enterEmail: 'Vul hieronder het e-mailadres in waarmee je je hebt aangemeld. U ontvangt een e-mail met een link om uw wachtwoord opnieuw in te stellen.',
    enterCorrectEmai: 'Voer het juiste formaat van het e-mailadres in.',
    passwordCharacters: 'Wachtwoord moet 8-16 tekens lang zijn',
    passwordDiff: 'De twee ingevoerde wachtwoorden zijn inconsistent',
    enterCode: 'Vul alstublieft de verificatiecode in.',
    sentSuccess: 'De e-mail is succesvol verzonden.',
    successfully: 'Inschrijven succesvol',
    pleaseEmail: 'Vul alstublieft uw e-mailadres in',
    pleasePassword: 'Voer uw wachtwoord in',
    accountActivated: 'Je account is niet geactiveerd.',
    enterCorrectPass: 'Voer het juiste e-mailadres of tijdelijke accountnaam en wachtwoord in.',
    resetPasseord: 'Om uw account te beschermen, klikt u op \"Wachtwoord vergeten\" om uw wachtwoord opnieuw in te stellen.',
    validEmail: 'Gelieve een geldig e-mailadres in te vullen',
    enterFirstName: 'Voer alstublieft uw voornaam in.',
    enterLastName: 'Voer alstublieft uw achternaam in.',
    reEnterPass: 'Voer alstublieft uw wachtwoord opnieuw in.',
    creatingAccount: 'Door een account aan te maken, gaat u akkoord met de',
    termsUse: 'Gebruiksvoorwaarden',
    privacyPolicy: 'Privacybeleid',
    thankYou: 'Dank je wel!',
    checkEmail: 'Controleer alstublieft uw e-mail.',
    confirmRegistration: 'om uw registratie te bevestigen. U kunt het activeringsproces overslaan en ons product normaal gebruiken, maar als u uw wachtwoord vergeet, kunnen we u niet helpen het te herstellen.',
    noteReceiveEmail: 'Heeft u geen e-mail ontvangen?',
    receiveConfirmationEmail: 'Als u geen bevestigingse-mail heeft ontvangen, stuur ons dan een e-mail op',
    buttonResend: 'of klik op de knop om opnieuw te verzenden.',
    forgetEmail: 'Bent u uw e-mailadres vergeten?',
    sendEmailSupport: ' Stuur een e-mail naar ondersteuning',
    trackDown: 'en we zullen het opsporen.',
    passwordnotMatch: 'Het wachtwoord dat u heeft ingevoerd, komt niet overeen.',
    enterVaildPassWord: 'Voer alstublieft een geldig wachtwoord in.',
    usernameNotContain: 'De gebruikersnaam mag geen speciale tekens bevatten.',
    updatedSuccessfully: 'Uw gegevens zijn succesvol bijgewerkt.',
    thankBindEmail: 'Bedankt voor het bindende e-mailadres, controleer de activeringsmail op tijd',
    failExceedOperation: 'Niet in staat om deze bewerking uit te voeren',
    enterNewPassword: 'Voer alstublieft het nieuwe wachtwoord in.',
    confirmationPassword: 'Voer alstublieft het bevestigingswachtwoord in.',
    userNameNot: 'Gebruikersnaam kan niet leeg zijn.',
    //login popup用
    signUp: 'Registreren',
    logInButton: 'Inloggen',
    logInWith: 'Inloggen met',
    logToMultCloud: 'Inloggen op MultCloud',
    logEmailInput: 'E-mail/Tijdelijke accountnaam',
    verificationIncorrect: 'De verificatie die u heeft ingevoerd is onjuist.',
    signUpTitle: 'Registreer en ontvang elke maand gratis 5GB aan dataverkeer.',
    title: "Verplaats het naar uw cloudservices met MultCloud.",
    tips: "Heeft u al een account?",
    tips2: "Heeft u nog geen account?",
    btnTxt: "Aanmelden...",
    facebook: "Facebook",
    google: "Google",
    exception: {
        strEmpty: "Vul dit veld in, alstublieft.",
        nameToLong: "Uw gebruikersnaam moet 1-20 tekens lang zijn.",
        emailError: "Voer alstublieft een geldig e-mailadres in.",
        pwdError: "Voer alstublieft een wachtwoord in met 8-16 tekens.",
        rePsdEmpty: "Voer alstublieft uw wachtwoord opnieuw in.",
        rePwdError: "Wachtwoorden komen niet overeen.",
        codeEmpty: "Voer alstublieft de verificatiecode in.",
        codeError: "De verificatiecode moet 4 tekens lang zijn.",
        verifyCodeInvalid: "De verificatiecode is niet correct.",
        emailExist: "Het e-mailadres is al geregistreerd.",
        emailPsdError: "E-mail/Tijdelijke accountnaam of wachtwoord is niet correct.",
    }
},
home: {
    driveNameNotContain: 'De schijfnaam mag geen speciale tekens bevatten: `/ \ | : * ? \" < >  &`.',
    cloudDiskName: 'De naam van de cloudschijf mag niet langer zijn dan 200 tekens.'
},
sharesPage: {
    linkFailure: 'Sorry, dit gedeelde bestand is geannuleerd.',
    linkMasking: 'Sorry, dit gedeelde bestand is geblokkeerd voor weergave.',
    saveCloud: 'Opslaan naar de cloud',
    directDownload: 'Directe download',
    saveLink: 'Link opslaan',
    cancelShare:'Delen annuleren',
    uploadFile: 'Bestand uploaden',
    newFolder: 'Nieuwe map',
    saveLinkSuccessBefore: 'U heeft de link succesvol opgeslagen.',
    saveLinkSuccessAfter: ' Bekijk opgeslagen links',
    saveLinkFail: 'Opslaan van de link mislukt..',
    downloadingFolder: 'Het downloaden van een map wordt op dit moment niet ondersteund.',
    downloadingMore: 'U kunt slechts één bestand tegelijk downloaden.',
    downloadingNone: 'Selecteer alstublieft een bestand.',
    sharecanceledSuccess: 'Delen geannuleerd.',
    sharecanceledFailed: 'Annuleren van delen mislukt.',
    newFolderInRoot: 'Voer alstublieft submappen in om een nieuwe map te maken.',
    uploadFileInRoot: 'Voer alstublieft submappen in om een bestand te uploaden.',
    selectFileTransfer: 'Selecteer alstublieft een bestand om over te dragen.',
    createTransferFailed: 'Mislukt om overdrachtstaak te creëren.',
    createTransferSuccessBefore: 'U heeft succesvol een overdrachtstaak aangemaakt.',
    createTransferSuccessAfter: ' Bekijk taak',
    addCloudService: 'Voeg cloudservice toe',
    mustAddClouds: 'U moet een geldige cloudopslag toevoegen.',
    selectSaveCloudTitle: 'Selecteer alstublieft',
    moreClouds:'Meer clouds',
    saveLinkExists: 'De link bestaat al.',
    errorShare404: 'Bronbestand niet gevonden.',
    passWordError: 'Onjuist wachtwoord!',
    passWordNone: 'Wachtwoord mag niet leeg zijn.',
    passWordInputTitle: 'MultCloud privé sharebestand',
    passWordInputMsg: 'Voer alstublieft het wachtwoord in.',
    passWordInputButton: 'OK',
    loginErrorMax: 'U heeft uw wachtwoord al een tijdje niet bijgewerkt, graag uw wachtwoord vernieuwen.',
    uploadFolder: 'Op dit moment kunt u alleen bestanden uploaden.',
    pleaseSignIn: 'Log alstublieft in op MultCloud.',
},
share:{
    noManageMyShare: "U kunt hier al uw gedeelde bestanden beheren.",
    noManageSavedShare: "U kunt hier alle opgeslagen gedeelde items beheren.",
    unknownError: "Het gedeelde bestand ontbreekt, het is mogelijk verplaatst of verwijderd.",
    privateShareText: "(Neem contact met mij op om het wachtwoord te ontvangen.)",
},
inviteFriends:{
    titleBefor: 'Nodig zoveel mogelijk vrienden uit als je kunt en krijg ',
    titleAfter: ' verkeer voor elke vriend die je uitnodigt! Geen quotumlimiet!',
    shareEmailTitle: 'Deel uitnodiging: ',
    shareLinkTitle: 'Deel uitnodigingslink: ',
    emailSend: 'Verzenden',
    emailTip: 'Voeg hier het e-mailadres toe',
    wonMonthFlows: 'Deze maand heb je levenslang extra verkeer gewonnen:',
    wonMonthTitle: 'Maak kans op levenslang ONBEPERKT dataverkeer!',
    lastWinner: 'Laatste winnaar',
    winnerInvites: 'Met {num} uitnodigingen',
    winnerTip: 'Won LIFETIME ONBEPERKT',
    statusTitle: 'Uw deelstatus',
    successInvites: 'Geslaagde uitnodigingen deze maand: ',
    chanceWin: 'Kans om te winnen: ',
    tipsTitle: 'Voorwaarden',
    tipsOne: 'Alleen uitgenodigde gebruikers met een geverifieerd e-mailadres tellen als een geslaagde uitnodiging.',
    tipsTwo: 'Er is geen quotumlimiet voor het verkeer dat u verdient door mensen uit te nodigen.',
    tipsThird: 'Als u al een abonnee bent voor onbeperkt verkeer, kunt u geen 2GB winnen met een geslaagde uitnodiging, maar uw kans om levenslange onbeperkte service te winnen wordt verdubbeld.',
    shareText: 'MultCloud - Verplaats en beheer uw meerdere cloudbestanden met één app. Word vandaag lid van MultCloud en ontvang een bonus van 2GB cloud-naar-cloud verkeer!',
},
paySystem:{
    billed:'In rekening gebracht tegen 0.099 € /GB voor extra verkeer',
    subCould:'Abonnees kunnen 50GB/5.9 € en 100GB/9.9 € gebruiken voor extra dataverkeer als het dataverkeer niet voldoende is.',
    limitedMonth:'150GB / maand',
    limitedTrafficMonth:'150GB verkeer per maand',
    unlimitedTraffic:'Onbeperkt verkeer voor het leven!',
    foraYear:'Onbeperkt verkeer voor een jaar',
    noNeedPurchase:'U hoeft geen extra verkeer aan te schaffen',
    yearlyPayment:'Jaarlijkse betaling (7.5 € /maand)',
    validityData:'De geldigheid van het dataverkeer dat u koopt, is permanent',
    additionalPackage:'Extra verkeerspakket',
    subscriptmc:'Uw abonnement op MultCloud',
    upgradeMore:'Upgrade naar MultCloud Premium voor meer overdrachtsverkeer en extra voordelen.',
    recommended:'Aanbevolen',
    toUnlimited:'Upgrade naar onbeperkt',
    otherPlan:'Andere plannen',
    moreTraffic:'Koop meer verkeer',
    monthlySubscriber:`U bent maandelijks geabonneerd en beschikt over 150GB dataverkeer om elke maand gegevens over te dragen of te synchroniseren tussen cloudopslagservices.`,
    moreDetails:`<a class='add-cloud-link sysLink'>Meer details over de privileges >></a>`,
    dataTraffic:'Dataverkeergebruik van de huidige maand',
    cloudTraffic:'Van cloud naar cloud-verkeer',
    buyNow:'Koop nu',
    specialOffer:'Speciale aanbieding',
    lifetimeFree:'Levenslang gratis',
    unsubscribe:'Uitschrijven',
    includes:'omvat',
    reSubscription:'Abonnement opnieuw activeren',
    monthTraffic:'Onbeperkt verkeer voor een maand',
    threeMonth:'30GB / maand',
    monthlyPayment:'Maandelijkse betaling',
    monthlyUnlimited:'Maandelijks onbeperkt',
    gb:'GB',
    YearlyUnlimited:'Jaarlijks onbeperkt',
    YearlyPaymentNine:'Jaarlijkse betaling (9.9 € /maand)',
    Onetime:'Eenmalige Betaling',
    twoMonthree:'200GB / maand x3',
    QuarterlyPayment:'Kwartaalbetaling (8.3 € /maand)',
    fourMOne:'400GB / maand x12',
    quarterlySubscriber:`U bent een kwartaalabonnee en u beschikt over 200GB dataverkeer om elke maand gegevens over te dragen of te synchroniseren tussen cloudopslagservices.`,
    yearlySubscriber:`U bent een jaarabonnee en u beschikt over 400GB dataverkeer om elke maand gegevens over te dragen of te synchroniseren tussen cloudopslagservices.`,
    expireIn:'Verloopt over',
    billYearly:'jaarlijks gefactureerd',
    billMonthly:'Maandelijks gefactureerd',
    billQuarterly:'Per kwartaal gefactureerd',
    twoMonTrafficthree:'200GB verkeer / maand x3',
    fourMTrafficOne:'400GB verkeer / maand x12',
    deleteSubAccount:'Je moet je uitschrijven om je account te verwijderen, weet je zeker dat je dit wilt doen?',
    payFirst:'Je moet',
    paybindEmail:`<a class='add-cloud-link sysLink'> bind uw e-mailadres en verifieer het </a>`,
    payEnd:'eerst voordat u zich abonneert, omdat we ervoor moeten zorgen dat u de belangrijke e-mails over uw abonnement met succes kunt ontvangen.',
    yearlyPaymentTxt:'Jaarlijkse betaling',
    quarterlyPaymentTxt:'Kwartaalbetaling',
    //2021-5-20新加
    upUnlimited:'Upgrade naar Jaarlijks Onbeperkt',
    payDiff:'Betaal alleen het prijsverschil!',
    yearlyUnlimit:'MultCloud (<b>Jaarlijks Onbeperkt</b>)',
    providesUnlimited:'Het Jaarlijks Onbeperkt-abonnement biedt onbeperkt dataverkeer voor de overdracht of synchronisatie van gegevens tussen cloudopslagservices gedurende 12 maanden.',
    subProduct:'Dit is een abonnementsproduct met een vergoeding van',
    perYear:'per jaar.',
    cancelSubscription:'U kunt uw abonnement op elk gewenst moment opzeggen.',
    defaultPayment:'De standaard betaalmethode is',
    anotherPayment:'Als u een andere betaalmethode wilt gebruiken, alstublieft ',
    clickHere:'Klik hier',
    tryAgain:'De betaling kan momenteel niet worden uitgevoerd. Controleer uw betaalmethode en probeer het opnieuw.',
    contactPayment:'Heeft u een probleem met de betaling? Neem gerust contact op met <a href="mailto:support@multcloud.com">support@multcloud.com</a>',
    Notice:'Kennisgeving',
    beforeBind:'Bind uw e-mailadres vast voordat u zich abonneert.',
    processorder:'Bestelling verwerken',
    eachGbMoney:'0.118 € /',
    eachGbMoneyT:'0.099 € /',
    payCouponQuartly:'Kwartaalbetaling (6.63 € /maand)',
    payCouponlimitedYearly:'Jaarlijkse betaling (5.83 € /maand)',
    payCouponunlimitedYearly:'Jaarlijkse betaling (7.49 € /maand)',
    payCouponunlimitedYearlyLow:'Jaarlijkse betaling (6.66 € /maand)',
    tips:'Tips: Als u vragen heeft, neem dan gerust contact op met:<div class="pay-scheme-email"></div><a href="mailto:support@multcloud.com">support@multcloud.com.</a>',
    monthly:'Maandelijks 150GB',
    //新版付费页面
    payTitle: 'Kies de juiste MultCloud voor jou!',
    limitedData: 'Beperkte gegevens',
    unlimitedData: 'Onbeperkte gegevens',
    monthly: 'Maandelijks',
    annually: 'Jaarlijks',
    save58: 'Bespaar tot 58%',
    payTip: 'Neem contact op met ons verkoopteam',
    limitTips: 'Ongebruikt dataverkeer zal zich ophopen',
    unlimitTips: 'Geen zorgen meer over datalimieten',
    tips2: 'Als u een probleem ondervindt tijdens de online aankoop, neem dan gerust contact met ons op via: <a href="mailto:support@multcloud.com">support@multcloud.com.</a>',
    vipUpgradeTips: 'Dit is het aanbod voor gebruikers van het {type}-plan.',
    tabPayScheme: {
        perMonth: 'Maandelijkse betaling',
        perYear: 'Jaarlijkse betaling',
        perNextYear: 'voor het eerste jaar wordt (hernieuwen bij {price})',
        refundDays: 'Dagen geld-terug-garantie',
        advanced: 'Geavanceerde functies',
        payPremium: 'Upgrade naar een premium abonnement en geniet van alle onderstaande geavanceerde functies',
        payUnlimited: 'Upgrade naar een UNLIMITED abonnement en geniet van alle onderstaande geavanceerde functies',
        freeTip1: 'Meer dataverkeer van cloud naar cloud',
        freeTip2: 'ONBEPERKT dataverkeer van cloud naar cloud',
        freeTip3: 'Geplande overdracht/synchronisatie/back-up',
        freeTip4: 'Dubbele synchronisatie',
        freeTip5: '10 Overdrachtsthreads',
        freeTip6: '8 synchronisatiemodi',
        freeTip7: 'Bestandsfilter',
        freeTip8: 'VIP-overdrachtsserver',
        freeTip9: 'VIP-klantenondersteuning',
        freeTip10: '5 Cloud-naar-cloud-taken parallel',
        freeTip11: 'Onbeperkte e-mailconversies',
        freeTipTitle1: 'Abonnees kunnen twee realtime synchronisatietaken en twee normale synchronisatietaken hebben (vier in totaal).',
        freeTipTitle2: 'Er zijn 10 overdrachtsthreads voor abonnees en 2 overdrachtsthreads voor gratis gebruikers.',
        freeTipTitle3: 'Tweerichtingssynchronisatie en 7 aangepaste opties in éénrichtingssynchronisatie, spiegelsynchronisatie ondersteund.',
        freeTipTitle4: 'Stel een filter in om bestanden met een door de gebruiker gedefinieerde bestandsnaam of bepaalde extensies automatisch over te dragen of te synchroniseren.',
        freeTipTitle5: 'Abonnees kunnen vijf cloud-naar-cloud-taken parallel uitvoeren, terwijl gratis gebruikers één taak tegelijk kunnen uitvoeren.',
        freeTipTitle6: 'Abonnees kunnen een onbeperkt aantal e-mails naar pdf\'s converteren, terwijl gratis gebruikers beperkt zijn tot het converteren van 50 e-mails per maand.',
    },
    nowPayScheme: {
        clearInsCountText: 'Maar het ongebruikte downloadquotum voor Instagram-profielen wordt gewist.',
        manageYourPlan: 'Beheer je abonnement',
        price: 'Prijs',
        paymentMethon: 'Betaalmethode',
        autoRenewal: 'Automatische verlenging',
        priceVat: 'Inclusief {currency}{vatPrice} BTW ({percent}% op {currency}{netPrice}).',
        defaultPayment: '{method}, xxxxxxxxxxxx{num}.',
        paypalPayment: 'De standaard betaalmethode is PayPal.',
        changePayment: 'Verander betaalmethode',
        activated: 'Volgende factureringsdatum {time}',
        deactivated: 'Volgende factureringsdatum {time}',
        appleTip: 'Uw huidige {name} is gekocht in de Apple Store.',
        appleTipId: 'Apple-transactie-ID: {id}.',
        googleTip: 'Je huidige {name} is gekocht in Google Play.',
        googleTipId: 'Google Play-bestellings-ID: {id}.',
        appNextTimeTip: 'Automatische verlenging is geactiveerd. De volgende factuurdatum is {time}',
        appNoSubscribe: 'Automatische verlenging is gedeactiveerd.',
    },
    // 免费用户弹窗
    freePlanPopup: {
        title_traffic: 'Oeps! Onvoldoende cloud-to-cloud-verkeer',
        title_ins: 'U heeft het downloadlimiet bereikt',
        title_pdf: 'Je hebt de limiet voor e-mail-naar-pdf-conversie bereikt',
        title_modes: 'Modus alleen voor Premium-abonnementen',
        title_remote: 'Je hebt de limiet voor remote upload bereikt',
        title_subtasks: 'Je hebt de limiet voor teamoverdracht bereikt',
        title_scheduled: 'Planningsfunctie alleen voor premium',
        title_speed: 'Vijfvoudige transfersnelheid alleen voor premium',
        title_sync: 'Je hebt de limiet voor normale synchronisatie bereikt',
        title_real: 'Je hebt de limiet voor realtime synchronisatie bereikt',
        title_filter: 'Bestandfilter is exclusief voor premium-abonnementen',
        desc: 'Upgrade om ALLE geavanceerde functies te ontgrendelen',
        itemTitle_th: 'Kenmerken en voordelen',
        itemTitle_traffic: 'Cloud-naar-cloud Verkeer',
        itemTitle_ins: 'Instagram-profielen om te downloaden',
        itemTitle_pdf: 'E-mail omzetten naar PDF',
        itemTitle_modes: 'Synchronisatiemodi',
        itemTitle_remote: 'Externe uploadtaken parallel',
        itemTitle_subtasks: 'Subaccounts tussen teams migreren',
        itemTitle_scheduled: 'Geplande overdracht/synchronisatie/backup',
        itemTitle_speed: 'Overdrachtsnelheid',
        itemTitle_sync: 'Normale synchronisatietaken parallel',
        itemTitle_real: 'Realtime synchronisatietaken parallel',
        itemTitle_filter: 'Bestandfilter',
        itemTitle_tran: 'VIP overdracht server',
        itemTitle_customer: 'VIP klantenservice',
        itemTitle_watermark: 'Watermerk uit PDF-e-mail verwijderen',
        itemValue_cur: 'Uw huidige',
        itemValue_free: 'gratis plan',
        itemValue_upgrade: 'Upgrade naar',
        itemvalue_premium: 'Premium',
        itemvalue_5gb: '5 GB / Maand',
        itemvalue_1profile: '1 Profie / Maand',
        itemvalue_50emails: '50 E-mails / Maand',
        itemvalue_maxUnlimited: 'Maximaal Onbeperkt',
        itemvalue_unlimited: 'Onbeperkt',
        button: 'Upgrade vanaf 9,99 €',
    },
    // 套餐的支持项
    supportItem: {
        yourCurPlan: 'Je huidige plan',
        // 第1组
        gb5: '5 GB gratis dataverkeer per maand',
        gb100: '100 GB dataverkeer per maand',
        gb200: '200 GB dataverkeer per maand',
        gb1200: '1200 GB gratis dataverkeer per jaar',
        gb2400: '2400 GB gratis dataverkeer per jaar',
        gbUnlimitedYear: 'Onbeperkt dataverkeer per jaar',
        gbUnlimitedLifetime: 'Onbeperkt dataverkeer voor het leven',
        gbPackage50: '',
        gbPackage100: '',
        gbGiveAway500: '',
        gbGiveAway200: '',
        ins1: '1 Ins-profiel om per maand te downloaden',
        ins10: '10 Ins-profielen om per maand te downloaden',
        ins20: '20 Ins-profielen om per maand te downloaden',
        ins120: '120 Ins-profielen om per jaar te downloaden',
        ins240: '240 Ins-profielen om per jaar te downloaden',
        insPackage50: '',
        insPackage100: '',
        insGiveAway500: '',
        insGiveAway200: '',
        pdf50: '50 e-mails per maand omzetten',
        pdfUnlimited: 'Onbeperkte e-mailomzettingen',
        threads2: '2 threads voor gegevensoverdracht',
        threads10: '10 threads voor gegevensoverdracht',
        scheduled: 'Geplande overdracht/synchronisatie/backup',
        // 第2组
        acrossClouds: 'Overdracht/synchronisatie/backup tussen clouds',
        offline: 'Offline overdracht/synchronisatie/backup',
        subAccounts3: 'Migreer 3 sub-accounts tussen teams',
        subAccounts1000: 'Migreer tot 1000 sub-accounts tussen teams',
        highSpeed: 'Geen ondersteuning voor hoge-snelheidsoverdracht',
        // 第3组
        syncMode4: '4 eenrichtings- / tweeweg-synchronisatiemodi',
        syncMode10: '10 eenrichtings- / tweeweg-synchronisatiemodi',
        realSync: 'Realtime synchronisatie',
        passwordProtected: 'Wachtwoord-beveiligde delen',
        subAccounts: 'Geen sub-account samenwerking',
        // 第4组
        cloud30: '30+ toonaangevende cloudopslagservices',
        unlimitedCloud: 'Voeg een onbeperkt aantal cloud-accounts toe',
        singleLog: 'Eén keer inloggen op alle clouds',
        support365: 'Geen prioriteitsondersteuning 24/7/365',
        // 其他
        unlimitedDataTraffic: 'Onbeperkt cloud-naar-cloud dataverkeer',
        unlimitedInsProfile: 'Onbeperkt downloaden van Ins-profielen',
        unlimitedAllFeatures: 'Alle premiumfuncties',
        // VIP弹窗标题
        vipPopupTitleTraffic: 'Je hebt al het dataverkeer verbruikt',
        vipPopupDescTraffic: 'Upgrade om onbeperkt dataverkeer te ontgrendelen',
        vipPopupTitleIns: 'Je hebt alle downloads van Instagram-profielen verbruikt',
        vipPopupDescIns: 'Upgrade om onbeperkte downloads van Instagram-profielen te ontgrendelen',
    },
    //套餐arguments参数翻译
    arguments: {
        //参数名
        title: {
            monthly100GB: '100GB / maand',
            monthly200GB: '200GB / maand',
            monthlyUnlimit: 'Onbeperkte data / maand',
            yearly1200GB: '1200GB / jaar',
            yearly2400GB: '2400GB / Year',
            yearlyUnlimit: 'Jaarlijks Onbeperkt',
            lifetimeUnlimit: 'Levenslang Onbeperkt',
            package50GB: '50GB',
            package100GB: '100GB',
            giveAway500GB: '500GB',
            giveAway200GB: '200GB',
        },
        tips: {
            monthly100GB: 'Bijvoorbeeld Je hebt de eerste maand slechts 50GB van 100GB verbruikt en de volgende maand heb je nog 50GB extra dataverkeer.',
            monthly200GB: 'Bijvoorbeeld Je hebt de eerste maand slechts 150GB of 200GB verbruikt en de volgende maand heb je nog 50GB extra dataverkeer.',
            monthlyUnlimit: '',
            yearly1200GB: 'Bijvoorbeeld Je hebt het eerste jaar slechts 1000GB of 1200GB verbruikt en het jaar daarop heb je nog 200GB extra dataverkeer.',
            yearly2400GB: 'Bijvoorbeeld Je hebt het eerste jaar slechts 2000GB of 2400GB verbruikt en het jaar daarop heb je nog 400GB extra dataverkeer.',
            yearlyUnlimit: '',
            lifetimeUnlimit: '',
            package50GB: 'Bijvoorbeeld Je hebt deze maand slechts 20GB van 50GB verbruikt, de ongebruikte 30GB blijft de volgende maand over',
            package100GB: 'Bijvoorbeeld Je hebt deze maand slechts 20GB van 100GB verbruikt, de ongebruikte 80GB blijft de volgende maand over',
        }
    }
},
//双重验证功能
twoStepverification:{
    bind:'E-mail eerst binden',
    addVerify:'U moet een manier toevoegen om te verifiëren.',
    phoneNotEmpty:'telefoonnummer mag niet leeg zijn.',
    addPhone:'Voeg een telefoonnummer toe',
    addAlEmail:'Voeg een alternatief e-mailadres toe',
    verifySet:'Verificatie-instelling',
    addWayVerify:'Voeg een manier toe om te verifiëren',
    enterEmail:'Voer uw e-mailadres in',
    enterPhone:'Vul je telefoonnummer in',
    enterCode:'Voer de code in die we hebben verzonden',
    enterCodeTip:'Controleer uw map met ongewenste e-mail en rapporteer geen spam of voeg \"no-reply@multcloud.email\" toe aan uw witte lijst.',
    codeExpired:'De verificatiecode is verlopen.',
    codeinCorrect:'De verificatiecode is onjuist. Controleer de code en probeer het opnieuw.',
    verificationTurnOn:'Tweestapsverificatie is ingeschakeld',
    recoverAccess:'Als u ooit de toegang tot uw account moet herstellen, kan deze code helpen. U moet het opschrijven en op een veilige plaats bewaren. We raden u ten zeerste aan uw herstelcode niet op een apparaat op te slaan.',
    longValid:'Als u eerder een herstelcode had, is deze niet meer geldig. Gebruik in plaats daarvan deze nieuwe code.',
    removeAll:'Alle apparaten verwijderen?',
    lostAccess:'We raden u aan dit te doen als u de toegang bent kwijtgeraakt tot een apparaat dat u vertrouwt.',
    removeMethod:'Remove Verification Method?',
    removeMethodSure:'Are you sure you want to remove the verification method? Removing it means that you will not be able to use it for verification.',
    getRecode:'Genereer een nieuwe code',
    emailCode:'E-mail een code',
    TextCode:'Sms een code',
    useAccount:'U gebruikt nu een tijdelijk account. Bind de e-mail en probeer het opnieuw.',
    removeTrusted:'Verwijder alle vertrouwde apparaten',
    finish:'Finish',
    newCode:'Uw nieuwe code is',
    twoStep:'Tweestapsverificatie',
    twoStepis:'Tweestapsverificatie is dat wel',
    on:'AAN',
    off:'UIT',
    cancel:'Annuleren',
    toManyCodeSend:'Er zijn te veel codes verzonden',
    verifyIdenti:'Identiteit verifiëren met',
    codeCopied:'Code gekopieerd!',
    copyCode:'Kopieer code',
    trustedDevice:'Vertrouwde apparaten verwijderd!',
    phoneValueTips:'Tips: Verwijder de voorloopnul en verwijder alle spaties, streepjes of haakjes.',
},
website: {
    cloneNow: 'Nu klonen',
    addTaskNow: 'Taak toevoegen en nu klonen',
    siteFromTitle: 'WEBSITE OM TE BACK-UPS MAKEN',
    siteFromDesc: 'Klik hier om de bronwebsitegegevens te selecteren die u wilt back-uppen',
    siteToTitle: 'WAAR DE BACK-UP OPSLAAN',
    siteToDesc: 'Klik hier om de cloudopslag of map te selecteren waarnaar u wilt overbrengen',
    sourceServers: 'Bronservers',
    targetServers: 'Doelservers',
    desc: 'Maak een back-up van uw websitebestanden en database naar de cloud, of migreer uw website naar een nieuwe host of domein.',
    addSite: 'Websitebestanden toevoegen',
    addSiteMore: 'Meer websitebestanden toevoegen',
    removeSite: 'Websitebestanden verwijderen',
    addDb: 'Database toevoegen',
    addDbMore: 'Meer websitedatabases toevoegen',
    removeDb: 'Websitedatabase verwijderen',
},
cloudBackup:{
    cloudBackup:'Cloud Backup',
    setUpCloud:'Stel een cloudback-uptaak in om een back-up te maken van onlinebestanden van de ene cloud naar de andere',
    filesBckupTarget: 'Doeldirectories',
    filesBckup:'BESTANDEN OM EEN BACK-UP TE MAKEN',
    selectSoure:'Klik hier om de broncloudbestanden te selecteren waarvan u een back-up wilt maken',
    saveBackup:'WAAR U EEN BACK-UP OPSLAAT',
    selectTarget:'Klik hier om de doelwolk te selecteren om de back-up op te slaan',
    backupNow:'Nu backuppen',
    canSelect:'U kunt maximaal 10,000 artikelen selecteren',
    backupFiles:'U kunt geen back-up van uw bestanden maken naar Google Foto\'s.',
    notSelectEvernoteBackup: 'U kunt geen back-up van uw bestanden maken naar Evernote.',
    backFlickr:'U kunt geen back-up van uw bestanden maken op Flickr.',
    thankSubscrib:'Bedankt dat u zich op onze service heeft geabonneerd. U kunt nu maximaal 10 bestanden tegelijk back-uppen.',
    maximunBack:'U kunt nu maximaal 2 bestanden tegelijk back-uppen. Upgrade naar een premiumservice om er maximaal 10 te hebben!',
    backSuccess:'Back-up Succes',
    backFailure:'Back-up Mislukking',
    successBck:'Er is een back-up gemaakt van alle bestanden',
    taskCanceled:'De taak is handmatig geannuleerd',
    notRestore:'Kan de bestanden niet vinden om te herstellen. Mogelijk zijn ze al verwijderd.',
    selectVersions:'Selecteer versies',
    restoreOptions:'Opties herstellen',
    selectFiles:'Selecteer bestanden die u wilt herstellen.',
    toRestore:'Selecteer een bestand om te herstellen.',
    originalLocation:'Originele locatie',
    thankRestore:'Bedankt dat u zich op onze service heeft geabonneerd. U kunt nu maximaal 10 bestanden tegelijk herstellen.',
    restoreSimult:'U kunt nu maximaal 2 bestanden tegelijk herstellen. Upgrade naar een premiumservice om er maximaal 10 te hebben!',
    restoreSuccess:'Herstel Succes',
    restorePartial:'Herstel Gedeeltelijk Succes',
    restoreFailure:'Herstel Mislukking',
    notRestore:'Kan de bestanden niet vinden om te herstellen. Mogelijk zijn ze al verwijderd.',
    backupTime:'Back-uptijd',
    changedFiles:'Gewijzigde bestanden',
    deleteVersion:'Weet u zeker dat u de back-upversie wilt verwijderen?',
    deleteFiles:'Verwijder de bestanden in deze versie',
    keepLatest:'Bewaar het nieuwste bestand',
    overWriteFile:'Overschrijf het bestand.',
    skipFile:'Sla het bestand over.',
    //2021-08-03添加
    versions:'Versies',
    backupTask:'Back-uptaak',
    readdCloud:'Voeg Cloud opnieuw toe',
    selectedCloud:'Sommige van de geselecteerde clouds zijn aan MultCloud toegevoegd voordat Cloud Backup werd uitgebracht. We raden u aan de clouds opnieuw aan MultCloud toe te voegen en het opnieuw te proberen.',
    continueAnyway:'Toch doorgaan',
    selectedHasAdded:'De geselecteerde cloud is aan MultCloud toegevoegd voordat Cloud Backup werd uitgebracht. We raden u aan de cloud opnieuw aan MultCloud toe te voegen en het opnieuw te proberen.',
    failCreate:'Het maken van de back-uptaak is mislukt.',
    failLoad:'Laden mislukt',
    pleaseReAdd:'voeg alstublieft de clouds opnieuw toe aan MultCloud',
    alreadyAdd:'Je hebt de clouddrive al toegevoegd.',
    failRename:'Hernoemen mislukt, omdat de bijbehorende map niet kan worden gevonden',
    taskRuning:'De taak is aan het lopen, wacht alstublieft tot de taak eindigt en probeer het opnieuw.',
    //2021-08-07添加
    oneBackup:'Je kunt slechts één back-up- of hersteltaak tegelijk uitvoeren',
    restoreTask:'Hersteltaak',
    restoreOriginal:'Herstel naar de oorspronkelijke locatie',
    restoreNewLocation:'Herstel naar nieuwe locatie',
    //2021-08-12添加
    backingUp:'Back-up bezig',
    restoring:'Herstellen bezig',
    restore:'Herstellen',
    backup:'Back-up',
    //2021-08-17添加
    maxNum:'Het maximale aantal bronitems is 1000. Selecteer minder items. P.S. Een hele map telt slechts één item.',
    maxLogs:'Tips: Het resultaat wordt afgekapt. Hier worden maximaal 1.000 mislukte bestanden weergegeven.',
    backupDetails:'Back-updetails',
    keepTwoFile:'Bewaar twee bestanden.',
    restoreDetails:'Gegevens herstellen',
    longerDelete:'Het kan langer duren als er een groot aantal bestanden moet worden verwijderd.',
    notFoundAim:'De doelmap kan niet worden gevonden',
    //2021-10-20
    backupNotWork:'De back-upservice werkt niet',
    //2021-10-28
    backupPartial:'Back-up Gedeeltelijk Geslaagd',
    configFile:'(Configuratiebestand uploaden)',
    //2021-11-16
    successRestore:'Succesvol alle bestanden hersteld',
    notFind:'Kunt u het configuratiebestand niet vinden, controleer dan of het configuratiebestand bestaat en of de verbinding tussen de clouddrive en MultCloud geldig is.',
    selectRestoreItems:'Selecteer de bestanden die je wilt herstellen',
    selectRestoreTotles:'Selecteer een map om te herstellen',
    original: 'Origineel',
    inTotalTip: '{count} bestanden, {size} in totaal',
},
affiliateProgram: {
    leftTitle: "Word onze affiliate",
    title: "MultCloud-affiliateprogramma",
    headTips1: "Verdien een commissie tot <span>50%</span>.",
    headTips2: "Meld u met een paar klikken aan, helemaal <span>gratis</span>.",
    headTips3: "Geen aanvullende voorwaarden, <span>iedereen</span> kan onze affiliate zijn!",
    signUpBtn: "Meld u aan voor een affilateaccount",
    tips: "Tips: Als u al aangesloten bent bij Cleverbridge, alsjeblieft <a href=\"https://console.partnerize.com/campaigns/manage-campaigns/join-campaigns/advertiser-details/1011l331\" target=\"_blank\"> log dan in </a>.",
    howDoTipsTitle: "Hoe werkt het",
    howDoTipsMsg: "Zodra u zich heeft aangemeld en ingelogd in ons partnerprogramma, kunt u AOMEI International Network Limited vinden onder het tabblad \'Campagnes - Sluit u aan bij een campagne\'. Klik erop en bevestig deelname. Zodra u deelneemt aan onze campagne, ziet u alle beschikbare MultCloud-producten. Als iemand MultCloud upgradet via uw verwijzingslink, wordt u betaald met een commissie van <span>30%-50%</span>",
    FAQsTitle: "Veelgestelde vragen over het MultCloud-affiliateprogramma",
    FAQ1: "Hoe werkt het affiliateprogramma?",
    answer1: "Zodra uw klant via uw verwijzingspagina heeft betaald, ontvangt u uw uitbetaling aan het begin van de volgende maand.",
    FAQ2: "Het klinkt fantastisch. Hoe meld ik mij aan?",
    answer2: "U kunt zich aanmelden door hierboven op \'Een partneraccount aanmelden\' te klikken. Met slechts een paar stappen heeft u uw partneraccount.",
    answerPs2: "Tips: Zodra u zich heeft aangemeld bij de console, kunt u AOMEI International Network Limited vinden onder het tabblad \'Campagnes\'. Klik erop en bevestig deelname.",
    FAQ3: "Hoeveel commissie krijg ik?",
    answer3: "De commissie verschilt per abonnement. Het commissietarief voor het maandabonnement is bijvoorbeeld 30%, maar voor het Lifetime Unlimited-abonnement is dit 50%.",
    FAQ4: "Hoe word ik betaald?",
    answer4: "Het hangt af van de \"betaalmethode\" die u heeft ingevuld. U krijgt altijd aan het begin van elke maand betaald.",
    answerPs4: "Tips: Er is geen minimumlimiet voor elke uitbetaling.",
    anyQuestionTitle: "Heeft u een vraag?",
    anyQuestionTip: "Neem gerust contact op met: <a href=\"mailto:affiliate@multcloud.com\" class=\"alink\">affiliate@multcloud.com</a>",
},
signUp: {
    pwdTip: "Wachtwoord (8-16 tekens)",
    signingUp: "Registreren . . .",
    tips2: "Door een account aan te maken, accepteert u de <a href=\"https://www.multcloud.com/terms\" class=\"alink\">Servicevoorwaarden <a/>&nbsp;en&nbsp;<a href=\"https://www.multcloud.com/policy\" class=\"alink\"> het Privacybeleid<a/>.",
    emailPushTip: "Door dit vakje aan te vinken, gaat u ermee akkoord e-mails van MultCloud te ontvangen over product-, service-updates, speciale aanbiedingen en evenementen. U kunt zich op elk moment afmelden.",
},
forgetPwd: {
    title: "Wachtwoord vergeten?",
    tip: "Vul uw e-mailadres in en wij sturen u een link om uw wachtwoord opnieuw in te stellen.",
    sending: "Het bericht wordt verzonden ...",
    btnTxt: "Stuur Reset E-mail",
    tips1: "Bent u uw e-mailadres vergeten?",
    tips2: " Stuur een e-mail naar ondersteuning",
    tips3: "en we zullen het opsporen.",
},
balackFriday: {
    lastTip: "Haast je, voordat het verdwijnt",
    title: "Vroegtijdige toegang tot Black Friday en Cyber Monday om onbeperkt cloud-naar-cloud dataverkeer te krijgen met 70% korting!",
    titleTip: "Haast je, zolang onze voorraad strekt!",
},
christmas: {
    payTxt: "Kerstuitverkoop",
    popupTitle: "MULTCLOUD-SUPERVERKOOP",
    pageTitle: "Ontvang levenslang ONBEPERKT cloud-naar-cloud-dataverkeer met {num}% OFF!",
    pageTitle2: "Get UNLIMITED Data Traffic for Lifetime with {num}% KORTING!",
    paysysTitle: "Schiet op, voordat het weg is!",
    popupTip1: "ONBEPERKT dataverkeer van cloud naar cloud",
    popupTip2: "10 snelle gegevensoverdrachtthreads",
    popupTip2Append: "Er zijn 10 overdrachtsthreads voor premium gebruikers en 2 overdrachtsthreads voor gratis gebruikers",
    popupTip3: "Geplande overdracht/synchronisatie/back-up",
    popupTip4: "Eénrichtings-/tweerichtingsrealtimesynchronisatie",
    popupTip4Append: "Er zijn zeven extra synchronisatiemodi voor premiumgebruikers. Spiegelsynchronisatie ondersteund",
    saledBtn: "WINKEL NU",
},
teamTransfer:{
    teamTransfer:'Teamoverdracht',
    transferMultiple:'Breng meerdere accounts over van het ene cloudplatform naar het andere (Google Workspace, OneDrive for Business, Dropbox Business, Box for Business, Shared Drive).',
    businessCloud:'Als u beheerder bent van zakelijke clouds, kunt u deze functie gebruiken om eenvoudig alle accounts van de ene zakelijke cloud naar de andere te migreren. Elke gebruiker heeft bijvoorbeeld een eigen map in een cloudplatform, MultCloud kan automatisch de mappen uit twee verschillende zakelijke clouds koppelen en de bestanden van de ene cloud naar de andere migreren.',
    clickSelect:'Klik hier om de zakelijke cloudservices te selecteren waarvan je gegevens wilt overzetten.',
    sourceAccount:'Bronaccounts',
    targetAccounts:'Doelaccounts',
    autoMatch:'Automatische match',
    likeTransfer:'Klik hier om de zakelijke cloudservices te selecteren waarnaar u wilt overstappen.',
    youMust:'Je moet',
    cloudService:' een zakelijke cloudservice toevoegen ',
    asAdmin:'Als beheerder eerst.',
    combinations:'Auto-Match zal de huidige combinaties opschonen, weet je zeker dat je doorgaat?',
    nosourceAccount:'Er is geen bronaccount of doelaccount.',
    noAccount:'Er zijn geen accounts voor Auto Match.',
    uploadCSV:'CSV uploaden',
    cleanCurrent :'Door CSV te uploaden worden de huidige combinaties opgeschoond, weet je zeker dat je doorgaat?',
    csvFile:'Het CSV-bestand dat u uploadt, moet overeenkomen met de ',
    csvFormat:'.CSV-indeling.',
    matchCsv:'De organisatie kan geen enkele combinatie uit het CSV-bestand matchen. Controleer het CSV-bestand en probeer het opnieuw.',
    alreadyAdd:'U heeft de combinatie van deze twee accounts al toegevoegd',
    cleanAll:'U staat op het punt alle geselecteerde combinaties op te schonen. Weet u zeker dat u doorgaat?',
    sure:'Ja ik weet het zeker',
    allTransferred:'Bewaar alle overgedragen bestanden in één map.',
    optionActivated:'Als deze optie is geactiveerd, worden alle overgedragen bestanden in één map van de doelwolk bewaard. De bronmap is bijvoorbeeld Google Workspace\\simon@multcloud.com en de doelmap is OneDrive for Business\\peter@multcloud.com. Alle bestanden in Google Workspace\\simon@multcloud.com worden overgezet naar OneDrive voor Business\\peter@multcloud.com\\simon@multcloud.com wanneer deze optie is geactiveerd.',
    organizationMigration:'Organisatie migratie',
    //jimin新增
    downloadCSV:'CSV downloaden',
    dontShow:'Laat dit niet meer zien',
    notSelected:'De gedeelde Drive van Google Workspace kan niet worden geselecteerd als doelcloud voor teammigratie.',
    batchMatch:'Batch-match',
    sourceCloud:'Broncloud toevoegen',
    targetCloud:'Doelwolk toevoegen',
    subTaskLimit:'Subtaaklimiet',
    freeUsers:'Gratis gebruikers kunnen 3 paar subtaken maken in een teamoverdrachtstaak. Upgrade naar de premiumversie en u kunt 1000 subtaken hebben in een teamoverdrachtstaak.',
    mostTeamTransfer:'3 subtaken in een teamoverdracht',
    substasksMost:'1000 subtaken in een teamoverdracht',
    mostTasks:'Het aantal subtaken kan maximaal 1000 bedragen.',
    timePassed:'De tijd die je hebt ingesteld is verstreken.'
},
shareTransfers: {
    logoMsg: '<span class="sf-logo-first">MultCloud</span><span class="sf-logo-name">Overdracht</span>',
    addFiles: 'Voeg bestanden toe vanuit Clouds',
    trnsfering: 'Overdracht bezig ...',
    sendingFile: 'Verzenden van {num} bestand(en)',
    sendingSize: '{now} van {all}',
    sendingTip: 'Overdrachtslink aan het maken, even geduld a.u.b.',
    cancelTransfer: 'Deze overdracht annuleren?',
    createdTransfer: 'Overdracht aangemaakt!',
    createShare: 'Maak Overdracht',
    signTitleByTransfer: 'Inloggen bij MultCloud om door te gaan',
    signupTitleByTransfer: 'Registreer je bij MultCloud om door te gaan',
    transferTitle: 'Titel',
    transferDescription: 'Beschrijving',
    addFileTip: '{num} bestand(en) toegevoegd',
    titleErrMsg: 'De titel mag niet langer zijn dan 128 tekens.',
    desErrMsg: 'De beschrijving mag niet langer zijn dan 512 tekens.',
    folder: 'Map',
},
summerSale: {
    titleTip: 'Hallo zomer',
    titleTip2: 'Ontvang ONBEPERKT cloud-to-cloud dataverkeer en beheer al uw zomerherinneringen moeiteloos tegen een scherpe prijs!',
    bottomTip: '- BESTE AANBIEDING VAN HET SEIZOEN –',
},
halloweenSale: {
    titleTip2: 'Bespaar tot 70% zonder trucjes, trakteer uzelf gewoon op onbeperkt dataverkeer van cloud naar cloud!',
    bottomTip: 'Haast je! Voordat het weg is.',
},
newYear: {
    payTxt: "NIEUWJAAR UITVERKOOP",
    titleTip: 'Luid het nieuwe jaar in met een superkorting van 70% op ONBEPERKT cloud-to-cloud dataverkeer!',
    bottomTip: 'Haast je! Voordat het weg is.',
},
backToSchool: {
    titleTip2: 'Ontvang ONBEPERKT cloud-naar-cloud dataverkeer en beheer al je schoolherinneringen voor een scherpe prijs!',
    bottomTip: '- BESTE AANBIEDING VAN HET SEIZOEN –',
},
blackFriday: {
    titleTip: 'Ontvang 70% KORTING op ONBEPERKT cloud-naar-cloud dataverkeer.',
    bottomTip: 'Haast je! Voordat het weg is.',
},
xmas: {
    titleTip: 'Geniet van een feestelijke korting van 70% op ONBEPERKT cloud-naar-cloud dataverkeer deze Kerst!',
    bottomTip: 'Haast je! Voordat het weg is.',
},
license: {
    codeTitle: 'Voer licentie in',
    codeTipTitle: 'Voer licentiecode in',
    codeTipText: 'Als je een licentiecode hebt, kun je deze gebruiken om de premiumdienst te activeren.',
    codeTipTextVip: 'Als je een licentiecode hebt, kun je deze gebruiken om te upgraden naar een geavanceerdere dienst.',
    codeFooter: 'Als u hulp nodig heeft, kunt u contact opnemen met:',
    showTitle: 'Licentiecode',
    showTip: 'De licentiecode is:',
    codeSucTitle: 'Premiumservice geactiveerd',
    codeSucTip: 'Premiumservice geactiveerd!',
},
filters: {
    taskList: {
        typeName: 'type',
        type: {
            all: 'Volledige lijst',
            copy: 'Tijdelijk',
            transfer: 'Cloudoverdracht',
            sync: 'Cloudsynchronisatie',
            backup: 'Cloudback-up',
            business: 'Teamoverdracht',
            remoteUpload: 'Extern uploaden',
            emailMigration: 'E-mailmigratie',
            restore: 'Cloudherstel',
        },
        statusName: "Status",
        status: {
            all: "Alle statussen",
            preset: 'Vooraf ingesteld',
            running: 'Actief',
            success: 'Succesvol',
            patial: 'Gedeeltelijk succes',
            failed: 'Mislukt',
            canceled: 'Geannuleerd',
        },
        dateName: "Datum",
        date: {
            all: 'Alle tijden',
            today: 'Vandaag',
            latestWeek: 'Afgelopen week',
            latestMonth: 'Afgelopen maand',
            customDate: 'Aangepaste datum',
        },
    }
},
schedule: {
    week1: "Zo",
    week2: "Ma",
    week3: "Di",
    week4: "Wo",
    week5: "Do",
    week6: "Vr",
    week7: "Za",
},
inputTab: {
    filterMessage: 'Druk op Enter om bestandsextensies toe te voegen',
}
}



// WEBPACK FOOTER //
// ./src/assets/i18n/nederlands.js